(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics', [
            // Plugins
            'ngTouch',
            'ngSanitize',
            'ngResource',
            'ui.router',
            'ui.bootstrap',
            'angular-storage',
            'uiGmapgoogle-maps',
            'ngMessages',
            'ui.select',
            'googlechart',
            'isteven-multi-select',
            'checklist-model',
            'ui-rangeSlider',
            'ngAnimate',
            'toastr',
            'angular-capitalize-filter',
            'ngQueue',
            'ngFileSaver',
            'ngMockE2E', // TO REMOVE after connect wih real API

            // App modules
            'NorvaldAnalytics.analytics',
            'NorvaldAnalytics.location',
            'NorvaldAnalytics.login',
            'NorvaldAnalytics.csv-data',
            'NorvaldAnalytics.delegatedLogin'
        ]);
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('pieChart', pieChart);

    /** @ngInject */
    function pieChart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/charts/pieChart/pieChart.html',
            controller: PieChartController,
            controllerAs: 'chart',
            bindToController: true,
            scope: {
                chartConfig: '=',
                chartTitle: '@'
            }
        };

        return directive;

        /** @ngInject */
        function PieChartController($scope, ChartData, $q, googleChartApiPromise, $rootScope) {
            var vm = this;
            vm.chartObject = {};

            $scope.$on('chartData:fetched', activate);

            activate();

            function activate() {
                resolveDataAndDrawChart();

                // it sets icons for legend list when icons are present
                if (vm.chartConfig.legend) {
                    if (vm.chartConfig.legend.icons) {
                        vm.legendIcons = vm.chartConfig.legend.icons;
                    }
                    vm.displayInMiddle =  (vm.chartConfig.legend.position == "top") || (vm.chartConfig.legend.position == "bottom");
                    vm.advanced = vm.chartConfig.legend.advancedType;
                }

                // it sets legend element colors when colors are present
                if (vm.chartConfig.colors) {
                    vm.legendStyleColors = vm.chartConfig.colors;
                }
            }

            function resolveDataAndDrawChart() {
                vm.loading = true;
                // It solves problem with displaying asynchronously received data from backend
                // vm.chartConfig.data have to be promise
                $q.all({ data: vm.chartConfig.data, api: googleChartApiPromise })
                    .then(configureChart);
            }

            function getPreparedChartData(data) {
                var convertedData = ChartData.convertToChartDataTable(data);
                if (convertedData.length > 0) {
                    // get array with name of columns from chartConfig scope or initialize empty array
                    var colNames = vm.chartConfig.columnNames || _.fill(Array(convertedData[0].length), '');
                    convertedData.unshift(colNames);
                    return google.visualization.arrayToDataTable(convertedData);
                }
            }

            function getPreparedCustomLegendData(data) {
                if (vm.chartConfig.legend && vm.chartConfig.legend.dataTypes) {
                    if ((_.indexOf(vm.chartConfig.legend.dataTypes, 'values') >= 0) &&
                        (_.indexOf(vm.chartConfig.legend.dataTypes, 'percentages') >= 0)) {
                        return ChartData.addPercentageColumnBasingOnLastColumn(data);
                    }
                }
            }

            function prepareColorsForChart(labels){
                return _.map(labels, function(e) {
                    var styleObject = _.find(vm.chartConfig.legend.style, {label: e});
                    return styleObject ? styleObject.color : 'white';
                });
            }

            function configureChart(result) {
                vm.chartObject.type = "PieChart";
                if(vm.chartConfig.name === 'TopApsGroupsTable') {
                    $rootScope.$broadcast('topApsGroup:fetched', result.data.data[0][0]);
                }
                
                var chartData;
                if (vm.chartConfig.maxCount) {
                    chartData = _.map(result.data.data, function(e){ return e.slice(0, vm.chartConfig.maxCount) });
                } else {
                    chartData = result.data.data;
                }
                vm.chartObject.displayed = true;
                vm.chartObject.data = getPreparedChartData(chartData);
                var legendDataArray = getPreparedCustomLegendData(ChartData.convertToChartDataTable(chartData));
                vm.customLegendData = ChartData.prepareLegendObjectForChartData(legendDataArray);
                vm.loading = false;

                vm.chartObject.options = {
                    "titleTextStyle": {
                        "fontSize": 14
                    },
                    "isStacked": "true",
                    "width": "100%",
                    "height": "100%",
                    "legend": {
                        "position": vm.chartConfig.legend && !vm.chartConfig.legend.custom ? vm.chartConfig.legend.position : 'none'
                    },
                    "pieHole": "0.6",
                    "pieSliceText": "none",
                    "chartArea": {
                        "left": "8",
                        "top": "50",
                        "width": "100%",
                        "height": "100%",
                    },
                    "colors": vm.chartConfig.colorsFromLabel ? prepareColorsForChart(result.data.data[0]) : vm.chartConfig.colors,
                    "tooltip": {
                        "textStyle": {
                            "fontSize": '14'
                        }
                    },
                    "backgroundColor": {
                        "fill": "transparent"
                    }
                };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('linearChart', linearChart);

    /** @ngInject */
    function linearChart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/charts/linearChart/linearChart.html',
            controller: LinearChartController,
            controllerAs: 'chart',
            bindToController: true,
            scope: {
                chartConfig: '=',
                hAxisTitle: '@',
                vAxisTitle: '@',
                chartTitle: '@',
                hAxisDateFormat: '&',
                vAxisBaseline: '@'
            }
        };

        return directive;

        /** @ngInject */
        function LinearChartController($scope, googleChartApiPromise, $q, ChartData) {
            var vm = this;
            vm.chartObject = {};

            $scope.$on('chartData:fetched', resolveDataAndDrawChart);

            activate();

            function activate() {
                resolveDataAndDrawChart();
            }

            // It solves problem with displaying asynchronously received data from backend
            // vm.chartConfig.data have to be promise
            function resolveDataAndDrawChart() {
                vm.loading = true;
                $q.all({ data: vm.chartConfig.data, api: googleChartApiPromise })
                    .then(configureChart);
            }

            function replaceSeriesOfChartData(chartData) {
                if (vm.chartConfig.seriesName) {
                    return ChartData.replaceNameOfSeries(chartData, vm.chartConfig.seriesName)
                }
                return chartData;
            }

            function configureChart(result) {
                var chartData;
                vm.loading = false;
                vm.chartObject.type = "LineChart";
                vm.chartObject.displayed = true;
                vm.chartObject.style = "point";

                if (vm.hAxisDateFormat()) {
                    chartData = ChartData.formatHAxisDataForLinearChart(result.data.data, vm.hAxisDateFormat());
                } else {
                    chartData = result.data.data;
                }


                if(vm.chartConfig.timeToDateTime) {
                    chartData = ChartData.convertTimeToDateTimeForDayUsage(chartData);
                }

                chartData = replaceSeriesOfChartData(chartData);

                // protection against incorrect data received in response
                if (chartData.length == 0) {
                    vm.chartObject.data = google.visualization.arrayToDataTable([['',''],['',0]]);
                } else if(chartData.length < 2){
                    chartData.push(_.map(chartData[0], function(e, idx){
                        return idx==0 ? '' : 0;
                    }));
                    vm.chartObject.data = chartData;
                } else {
                    vm.chartObject.data = vm.chartConfig.hAxisParseToDateTime ? ChartData.parseColumnToDate(0, chartData) : chartData;
                }

                vm.chartObject.options = {
                    "annotations": {
                        "style": 'point'
                    },
                    "pointSize": "7",
                    "pointsVisible": angular.isUndefined(vm.chartConfig.pointVisible) ? true : vm.chartConfig.pointVisible,
                    "colors": [ '#29B29B', '#1F232B', '#207567', '#8C9AAB',],
                    "defaultColors":  [ '#29B29B', '#1F232B', '#207567', '#8C9AAB',],
                    "isStacked": "true",
                    "interpolateNulls": true,
                    "legend": {
                        "position": "bottom",
                        "textStyle": {
                            "fontSize": 12.5,
                            "color": "#4A4A4A"
                        },
                        "maxLines": 2
                    },
                    "width": "100%",
                    "fill": 20,
                    "displayExactValues": true,
                    "vAxis": {
                        "title": vm.vAxisTitle,
                        "baselineColor": "#DBDBDB",
                        "gridlines": {
                            "count": 6
                        },
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        },
                        "format": "",
                        "minValue": vm.vAxisBaseline
                    },
                    "hAxis": {
                        "title": vm.hAxisTitle,
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        },
                        "slantedText": vm.chartConfig.hSlantedText ? vm.chartConfig.hSlantedText.present : false,
                        "slantedTextAngle": vm.chartConfig.hSlantedText ? vm.chartConfig.hSlantedText.angle : 0,
                        "maxAlternation": 1,
                        "maxTextLines": 1,
                        "gridlines": {
                            "count": vm.chartConfig.hGridlinesCount ? vm.chartConfig.hGridlinesCount : 0
                        },
                        "format": ""
                    },
                    "chartArea": {
                        "left": "60",
                        "right": "0",
                        "top": "35",
                        "width": "100%"
                    },
                    "vAxes": angular.isUndefined(vm.chartConfig.vAxes) ? {} : vm.chartConfig.vAxes(vm.chartObject.data),
                    "series": vm.chartConfig.series || {}
                };

                // Use short axis label on big numbers
                if(vm.chartConfig.name === 'UsageOverTimeOfDayPlot') {
                    // Transform hour from '12:00:00' into '12h'
                    _.forEach(vm.chartObject.data, function(value, key) {
                        if(key) {
                            vm.chartObject.data[key][0] = value[0].substring(0, 2).replace(/^0+(?!\.|$)/, '') + 'h';
                        }
                    });

                    vm.chartObject.options.vAxis.format = "short";
                }

                if(vm.chartConfig.name === 'UpDownVolumeAndNewRecurringSessionsPerTimePlot') {
                    vm.chartObject.options.chartArea.right = "60";
                    vm.chartObject.options.vAxis.format = "short";
                }

                $scope.$emit("chart:resolved", vm.chartConfig.name);
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('customChartLegend', customChartLegend);

    /** @ngInject */
    function customChartLegend() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/charts/customChartLegend/customChartLegend.html',
            controller: CustomChartLegend,
            controllerAs: 'legend',
            bindToController: true,
            scope: {
                data: '=',
                colors: '=',
                icons: '=',
                advanced: '=',
                legendStyle: '='
            }
        };

        return directive;

        /** @ngInject */
        function CustomChartLegend() {
            var vm = this;

            vm.styleColorForLabel = styleColorForLabel;
            vm.iconForLabel = iconForLabel;

            activate();

            function activate() {
                // when 'customized-symbol' then list symbols are icons passed in scope, otherwise list style type is disc (circle with fulfillment)
                vm.listStyleType = vm.icons ? 'customized-symbol' : 'normal';
            }

            function styleColorForLabel(label) {
                if (!vm.legendStyle) {
                    return null;
                }
                var styleForLabel = _.find(vm.legendStyle, { label: label })
                if (styleForLabel) {
                    return { color: styleForLabel.color }
                }
            }

            function iconForLabel(label) {
                var styleForLabel = _.find(vm.legendStyle, { label: label })
                if (styleForLabel) {
                    return styleForLabel.icon
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('columnChart', columnChart);

    /** @ngInject */
    function columnChart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/charts/columnChart/columnChart.html',
            controller: ColumnChartController,
            controllerAs: 'chart',
            bindToController: true,
            scope: {
                chartConfig: '=',
                chartTitle: '@'
            }
        };

        return directive;

        /** @ngInject */
        function ColumnChartController($scope, ChartData, $q, googleChartApiPromise) {
            var vm = this;
            vm.chartObject = {
                type: "ColumnChart"
            };

            $scope.$on('chartData:fetched', resolveDataAndDrawChart);

            activate();

            function activate() {
                resolveDataAndDrawChart();
            }

            function resolveDataAndDrawChart() {
                vm.loading = true;
                // It solves problem with displaying asynchronously received data from backend
                // vm.chartConfig.data have to be promise
                $q.all({ data: vm.chartConfig.data, api: googleChartApiPromise})
                    .then(configureChart);
            }

            function getPreparedChartData(data) {
                var convertedData = ChartData.convertToChartDataTable(data);
                // get array with name of columns from chartConfig scope or initialize empty array
                var colNames = vm.chartConfig.columnNames || _.fill(Array(convertedData[0].length), '');
                convertedData.unshift(colNames);
                return google.visualization.arrayToDataTable(convertedData);
            }

            function configureChart(result) {
                var chartData = result.data.data;
                vm.chartObject.displayed = true;
                vm.chartObject.data = getPreparedChartData(chartData);
                vm.loading = false;

                vm.chartObject.options = {
                    "titleTextStyle": {
                        "fontSize": 14
                    },
                    "width": "100%",
                    "height": "100%",
                    "legend": {
                        "position": 'none'
                    },
                    "vAxis": {
                        "baselineColor": "#DBDBDB",
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        }
                    },
                    "hAxis": {
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        }
                    },
                    "chartArea": {
                        "left": "50",
                        "top": "50",
                        "width": "100%",
                        "height": "70%"
                    },
                    "colors": vm.chartConfig.colors,
                    "tooltip": {
                        "textStyle": {
                            "fontSize": '14'
                        }
                    }
                };
            }

        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('areaChart', areaChart);

    /** @ngInject */
    function areaChart() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/charts/areaChart/areaChart.html',
            controller: AreaChartController,
            controllerAs: 'chart',
            bindToController: true,
            scope: {
                chartConfig: '=',
                hAxisTitle: '@',
                vAxisTitle: '@',
                chartTitle: '@',
                hAxisDateFormat: '&'
            }
        };

        return directive;

        /** @ngInject */
        function AreaChartController($scope, googleChartApiPromise, $q, ChartData) {
            var vm = this;
            vm.chartObject = {};
            
            $scope.$on('chartData:fetched', resolveDataAndDrawChart);

            activate();

            function activate() {
                resolveDataAndDrawChart();
            }
            
            // It solves problem with displaying asynchronously received data from backend
            // vm.chartConfig.data have to be promise
            function resolveDataAndDrawChart() {
                vm.loading = true;
                $q.all({ data: vm.chartConfig.data, api: googleChartApiPromise })
                    .then(configureChart);
            }

            function configureChart(result) {
                vm.loading = false;
                vm.chartObject.type = "AreaChart";
                vm.chartObject.displayed = true;
                
                if (vm.hAxisDateFormat()) {
                    vm.chartObject.data = ChartData.formatHAxisDataForLinearChart(result.data.data, vm.hAxisDateFormat());
                } else {
                    vm.chartObject.data = result.data.data;
                }
                // ['#29B29B', '#239985', '#54FFE3', '#32686E', '#2D4245', '#151C24', '#1F232B', '#0F2A4A', '#566178', '#8C9AAB', '#78663E', '#2B281F'],    
                vm.chartObject.options = {
                    "colors": ['#29B29B', '#239985', '#54FFE3', '#32686E', '#2D4245', '#151C24', '#1F232B', '#0F2A4A', '#566178', '#8C9AAB', '#78663E', '#2B281F'],
                    "defaultColors":  ['#29B29B', '#1F232B', '#025244', '#8C9AAB',],
                    "isStacked": "false",
                    "legend": {
                        "position": "bottom",
                        "textStyle": {
                            "fontSize": 13,
                            "color": "#4A4A4A"
                        }
                    },
                    "width": "100%",
                    "fill": 20,
                    "displayExactValues": true,
                    "vAxis": {
                        "title": vm.vAxisTitle,
                        "baselineColor": "#DBDBDB",
                        "gridlines": {
                            "count": 5
                        },
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        }
                    },
                    "hAxis": {
                        "title": vm.hAxisTitle,
                        "textStyle": {
                            "fontSize": 11,
                            "color": "#4A4A4A"
                        },
                        "slantedText": vm.chartConfig.hSlantedText ? vm.chartConfig.hSlantedText.present : false,
                        "slantedTextAngle": vm.chartConfig.hSlantedText ? vm.chartConfig.hSlantedText.angle : 0,
                        "maxAlternation": 1,
                        "maxTextLines": 1
                    },
                    "chartArea": {
                        "left": "65",
                        "top": "35",
                        "width": "100%"
                    },
                    "vAxes": angular.isUndefined(vm.chartConfig.vAxes) ? {} : vm.chartConfig.vAxes(vm.chartObject.data)
                };
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics.login', []);

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.login')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider)
    {
      $stateProvider
          // Location page
          .state('login', {
              url: '/login',
              templateUrl: 'app/pages/login/login.html',
              controller: 'LoginController',
              controllerAs: 'login',
              data: {}
          })
    }
})();

(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController(AuthService, $state, CONSTANTS) {
        var vm = this;

        vm.login = login;
        vm.clearErrors = clearErrors;

        function login() {
            window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?app=' + CONSTANTS.APP_IDENTIFIER + '&errorMessage=' + 'Deprecated authentication used';
        }

        function clearErrors() {
            vm.error = '';
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.location', []);

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.location')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider)
    {
      $stateProvider
          // Location page
          .state('location', {
              url: '/location',
              templateUrl: 'app/pages/location/location.html',
              controller: 'LocationController',
              controllerAs: 'location',
              data: {}
          })
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics.location')
        .controller('LocationController', LocationController);

    /** @ngInject */
    function LocationController($scope, ChartData, uiGmapIsReady, $rootScope) {

        // TODO
        // This variable specify widgetName request parameter for heat map
        // It should be replaced by proper widget name when vSPOT server issue will be supported
        // Now the widget name for heat map is the same like performance map name = "TimeSpentOnApMap"
        // so currently heat map displays the same data like performance map
        var HEATMAP_WIDGET_NAME = "TimeSpentOnApMap"; //"HeatMapData"

        $scope.$on('circlePopup:opened', setOpenedPopup);
        $scope.$on('filters:changed', getWidgetData);

        var vm = this;
        vm.impersonationActive = true;

        vm.map = {
            center: {
                latitude: 50.542160,
                longitude: 4.464967
            },
            zoom: 7,
            showHeat: false,
            heatLayerCallback: initializeHeatLayer,
            heatLayer: { } //store instance of heatLayer
        };

        vm.genderChart = {
            name: 'DistributionOfGenderBar',
            data: null,
            colorsFromLabel: true,
            legend: {
                custom: true,
                position: "right",
                icons: true,
                dataTypes: ['values', 'percentages'],
                style: [
                    { label: 'Male', icon: 'icon-gender-male', color: '#18A1CE' },
                    { label: 'Female', icon: 'icon-gender-female', color: '#E03373' },
                    { label: 'Unknown', icon: 'icon-gender-unknown', color: '#29B29B' }
                ]
            }
        };

        vm.ageChart = {
            name: 'DistributionByAgeHistogram',
            data: null,
            colorsFromLabel: true,
            legend: {
                custom: true,
                position: "right",
                dataTypes: ['values', 'percentages'],
                icons: true,
                style: [
                    { label: '13-18', icon: 'fa fa-circle', color: '#29B29B' },
                    { label: '18-21', icon: 'fa fa-circle', color: '#32686E' },
                    { label: '21+', icon: 'fa fa-circle', color: '#1F232B' }
                ]
            }
        };

        vm.totalUsersWidget = {
            name:  'TotalUsersNumber'
        };

        vm.totalUsersCountedWidget = {
            name: 'TotalUsersCounted'
        }

        vm.popupIsOpened = popupIsOpened;
        vm.closePopup = closePopup;
        vm.mapIsLoading = mapIsLoading;
        vm.toggleHeatMap = toggleHeatMap;

        activate();

        function activate() {
            catchWhenMapLoadingIsComplete();
            getWidgetData();
            $rootScope.$broadcast('ap:loaded');
        }

        function getWidgetData() {
            displayPointsOnMap();
            vm.map.heatLayerInitialized && fetchDataForHeatMap();
            vm.genderChart.data = getDataForWidgetObjectName(vm.genderChart.name);
            vm.ageChart.data = getDataForWidgetObjectName(vm.ageChart.name);
            vm.totalUsersWidget.data = getDataForWidgetObjectName(vm.totalUsersWidget.name);
            vm.totalUsersCountedWidget.data = getDataForWidgetObjectName(vm.totalUsersCountedWidget.name);

            ChartData.sendFetchedDataEvent();
        }

        function displayPointsOnMap() {
            closePopup();
            vm.mapLoading = true;
            ChartData.getChartData('TimeSpentOnApMap').then(function(response) {
                vm.circles = ChartData.parseLocationPerformanceData(response.data);
                if (vm.circles.length > 0) {
                    var bounds = new google.maps.LatLngBounds();
                    for (var i = 0; i < vm.circles.length; i++) {
                        var position = new google.maps.LatLng(vm.circles[i].center.latitude, vm.circles[i].center.longitude);
                        if (position.lat() != 0 && position.lng() != 0) {
                            bounds.extend(position);
                        }
                    }
                    vm.map.bounds = {
                        'northeast': {
                            'latitude': bounds.getNorthEast().lat(),
                            'longitude': bounds.getNorthEast().lng()
                        },
                        'southwest': {
                            'latitude': bounds.getSouthWest().lat(),
                            'longitude': bounds.getSouthWest().lng()
                        }
                    };
                }
                vm.mapLoading = false;
            });
        }

        function catchWhenMapLoadingIsComplete() {
            vm.initialMapLoading = true;
            uiGmapIsReady.promise().then(function(instances) {
                vm.initialMapLoading = false;
            });
        }

        function setOpenedPopup(event, id) {
            vm.openedPopupId = id;
        }

        function popupIsOpened(id) {
            return id == vm.openedPopupId;
        }

        function closePopup() {
            vm.openedPopupId = {};
        }

        function mapIsLoading() {
            return vm.initialMapLoading || vm.mapLoading;
        }

        function getDataForWidgetObjectName(widgetName) {
            return ChartData.getChartData(widgetName);
        }

        function toggleHeatMap() {
            if (!vm.map.heatDataLoading) {
                vm.map.showHeat = !vm.map.showHeat;
            }
        }

        // Fetch data for heatmap and set points with latitude and longitude
        function fetchDataForHeatMap() {
            vm.map.heatDataLoading = true;
            ChartData.getChartData(HEATMAP_WIDGET_NAME).then(function(response) {
                vm.map.heatDataLoading = false;
                vm.map.heatPoints = response.data;
                setPointsForHeatMap(vm.map.heatLayer);
            });
        }

        function setPointsForHeatMap(heatLayer) {
            var gradient = [
                'rgba(39, 125, 230, 0)',
                'rgba(48, 157, 200, 0.5)',
                'rgba(48, 157, 200, 0.8)',
                'rgba(4, 212, 94, 0.83)',
                'rgba(33, 204, 73, 0.84)',
                'rgba(50, 214, 4, 0.84)',
                'rgba(50, 214, 4, 0.85)',
                'rgba(50, 214, 4, 0.85)',
                'rgba(50, 255, 4, 0.87)',
                'rgba(59, 245, 12, 0.88)',
                'rgba(117, 245, 12, 0.89)',
                'rgba(183, 245, 12, 0.9)',
                'rgba(198, 245, 12, 0.91)',
                'rgba(237, 245, 8, 0.93)',
                'rgba(255, 38, 0, 1)'
            ];
            var heatPoints = _.map(vm.map.heatPoints, function(e){
                return new google.maps.LatLng(e.lat, e.lng);
            });
            var pointArray = new google.maps.MVCArray(heatPoints);

            heatLayer.set('radius', 60);
            heatLayer.set('gradient', gradient);
            heatLayer.setData(pointArray);
        };

        function initializeHeatLayer(heatLayer) {
            vm.map.heatLayer = heatLayer;
            vm.map.heatLayerInitialized = true;
            fetchDataForHeatMap();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics.delegatedLogin', []);

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.delegatedLogin')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider)
    {
      $stateProvider
          // Location page
          .state('delegatedLogin', {
              url: '/auth',
              templateUrl: 'app/pages/delegatedLogin/delegatedLogin.html',
              controller: 'DelegatedLoginController',
              controllerAs: 'delegatedLogin',
              data: {}
          })
    }
})();

(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics.delegatedLogin')
        .controller('DelegatedLoginController', DelegatedLoginController);

    /** @ngInject */
    function DelegatedLoginController(AuthService, $state, $location) {
        var vm = this;

        vm.delegatedLogin = delegatedLogin;
        vm.clearErrors = clearErrors;

        function delegatedLogin() {
            vm.loginProcess = true;

            clearErrors();

            /*AuthService.delegatedLogin(
                $location.search()['token'],
                $location.search()['identifier']
            ).then(function (data) {
                $state.go('analytics');
            }, function (data) {
                console.log(data);
            });*/
        }

        function clearErrors() {
            vm.error = '';
        }

        this.delegatedLogin();
    }
})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.csv-data', []);

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.csv-data')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider)
    {
      $stateProvider
          // Analytics page
          .state('csv-data', {
              url: '/csv-data',
              templateUrl: 'app/pages/csv-data/csv-data.html',
              controller: 'CsvController',
              controllerAs: 'csv',
              data: {}
          })
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics.csv-data')
        .controller('CsvController', CsvController);

    /** @ngInject */
    function CsvController($scope, CONSTANTS, $http, FileSaver, Blob, AuthService) {
        var dataUrl = CONSTANTS.CORE_API_URL + 'client/'+ AuthService.getClientId() + '/rawdata';
        var downloadUrl = CONSTANTS.CORE_API_URL + 'client/'+ AuthService.getClientId() + '/rawdata/download';
        var headers = {
            'X-WSSE': AuthService.getTokenHeader(),
            'Authorization': 'WSSE profile="UsernameToken"'
        }

        getRawDataFiles();

        function getRawDataFiles() {
            var req = {
                method: 'GET',
                url: dataUrl,
                headers: headers
            }
            $http(req).then(function(response) {
                $scope.rawDataFiles = response.data;
            });
        }

        $scope.getRawDataFile = function (id, filename){
            if ($scope.waiting === '') {
              $scope.waiting = 'waiting';
              var req = {
                  method: 'GET',
                  url: downloadUrl + '/' + id,
                  headers: headers
              }
              $http(req).then(function(response) {
                var data = new Blob([response.data], { type: 'text/csv;charset=utf-8' });
                FileSaver.saveAs(data, filename);
                $scope.waiting = '';
              });
            }
        }

        $scope.waiting = '';
        $scope.orderByField = 'date';
        $scope.reverseSort = true;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.analytics', []);

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics.analytics')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider)
    {
      $stateProvider
          // Analytics page
          .state('analytics', {
              url: '/analytics',
              templateUrl: 'app/pages/analytics/analytics.html',
              controller: 'AnalyticsController',
              controllerAs: 'analytics',
              data: {}
          })
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics.analytics')
        .controller('AnalyticsController', AnalyticsController);

    /** @ngInject */
    function AnalyticsController(ChartData, $scope, filtersFactory, FileExporter, $timeout, $rootScope) {
        $scope.$on('filters:changed', getChartsData);
        $scope.$on('chart:resolved', setWidgetAvailibity);
        $scope.$on('topApsGroup:fetched', showMostActiveApsGroup);

        var vm = this;

        vm.exportToPng = exportToPng;
        vm.exportToExcel = exportToExcel;
        vm.exportingToPngDisabled = exportingToPngDisabled;
        vm.exportingToExcelDisabled = exportingToExcelDisabled;
        vm.impersonationActive = true;

        // View model variables
        vm.activityChart = new widgetObject('UsersAndSessionsActivityPerTimePlot');
        vm.totalUsersWidget = new widgetObject('TotalUsersNumber');
        vm.totalSessionsWidget = new widgetObject('TotalSessionsNumber');
        vm.averageDurationWidget = new widgetObject('AverageDurationNumber');
        vm.facebookConnectWidget = new widgetObject('FacebookConnectNumber');
        vm.twitterConnectWidget = new widgetObject('TwitterConnectNumber');
        vm.mostPopularFlowWidget = new widgetObject('MostPopularFlow');
        vm.mostUsedDeviceWidget = new widgetObject('MostUsedDeviceName');
        vm.peakWidget = new widgetObject('PeakNumber');
        vm.popularLanguageWidget = new widgetObject('PopularLanguageName');
        vm.averageSessionTimeChart = new widgetObject('AvgSessionTimeBar', null, ['#29B29B']);
        vm.top10LanguagesChart = new top10PieChartObject('TopLanguagesTable');
        vm.mostPopular10ApsChart = new top10PieChartObject('TopApsTable');
        vm.mostPopular10ApsGroupsChart = new top10PieChartObject('TopApsGroupsTable');
        vm.evolutionOfProfilesChart = new widgetPlotObject('EvolutionOfProfilesChart', { present: false, angle: 23 });
        vm.sessionsStackedPlotChart = new widgetPlotObject('SesionPerTimePlot', { present: false, angle: 23 });
        vm.averageSessionBandwidthChart = new widgetObject('AvgSessionBandwidthBar', null, ['#29B29B']);
        vm.averageSessionPerProfileChart = new widgetObject('AvgSessionPerProfileBar', null, ['#29B29B']);
        vm.loginMethodChart = new top10PieChartObject('LoginMethodChart');
        vm.deviceBrandChart = new top10PieChartObject('DistributionOfDeviceBrandsTable');
        vm.deviceBrowserChart = new top10PieChartObject('DistributionOfDeviceBrowsersTable');
        vm.deviceOSChart = new top10PieChartObject('DistributionOfDeviceOsTable');
        vm.usersChart = new widgetObject('NewAndRecurringUsersPerTimePlot');
        vm.usageOverTimeChart = new widgetObject('UsageOverTimeOfDayPlot', null, ['#29B29B']);

        vm.genderChart = {
            name: 'DistributionOfGenderBar',
            data: null,
            colorsFromLabel: true,
            legend: {
                custom: true,
                position: "right",
                icons: true,
                dataTypes: ['values', 'percentages'],
                style: [
                    { label: 'Male', icon: 'icon-gender-male', color: '#18A1CE' },
                    { label: 'Female', icon: 'icon-gender-female', color: '#E03373' },
                    { label: 'Unknown', icon: 'icon-gender-unknown', color: '#29B29B' }
                ]
            }
        };

        vm.ageChart = {
            name: 'DistributionByAgeHistogram',
            data: null,
            colorsFromLabel: true,
            legend: {
                custom: true,
                position: "right",
                dataTypes: ['values', 'percentages'],
                icons: true,
                style: [
                    { label: '13-18', icon: 'fa fa-circle', color: '#29B29B' },
                    { label: '18-21', icon: 'fa fa-circle', color: '#32686E' },
                    { label: '21+', icon: 'fa fa-circle', color: '#1F232B' }
                ]
            }
        };
        // ['#29B29B', '#1F232B', '#025244', '#8C9AAB',]
        vm.devicesChart = {
            name: 'DistributionOfDeviceTypesTable',
            data: null,
            colorsFromLabel: true,
            legend: {
                custom: true,
                style: [
                    { label: 'smartphone', color: '#29B29B' },
                    { label: 'tablet', color: '#025244' },
                    { label: 'desktop', color: '#1F232B' },
                    { label: 'phablet', color: '#8C9AAB' },
                    { label: 'Unknown', color: '#2D4245' }
                ],
                advancedType: 'devices',
                position: "bottom",
                dataTypes: ['values', 'percentages']
            }
        };

        vm.volumesAndSessionsChart = {
            name: 'UpDownVolumeAndNewRecurringSessionsPerTimePlot',
            seriesName: {
                1: 'Recurring sessions',
                2: 'New sessions',
                3: 'Volume down',
                4: 'Volume up'
            },
            colors: ['#29B29B', '#239985', '#54FFE3', '#32686E', '#2D4245', '#151C24', '#1F232B', '#0F2A4A', '#566178', '#8C9AAB', '#78663E', '#2B281F'],
            series: {
                0: { targetAxisIndex: 0 },
                1: { targetAxisIndex: 0 },
                2: { targetAxisIndex: 1 },
                3: { targetAxisIndex: 1 }
            },
            vAxes: function(dataArray) {
                var maxValue = ChartData.getMaximumValueForSeries(dataArray, [3, 4]);
                var roundedMaxValue = ChartData.getRoundedToMultiply(maxValue);

                return {
                    0: { },
                    1: { ticks: new ChartData.BGbFormater(roundedMaxValue, 6).formatedTicks() }
                }
            }
        };

        vm.bandwidthStackedPlotChart = {
            name: 'BandwidthPlot',
            pointVisible: false,
            hSlantedText: {
                present: false,
                angle: 23
            },
            vAxes: function(dataArray) {
                var maxValue = ChartData.getRoundedMaximumValueForSeries(dataArray, [1,2], 2);
                var roundedMaxValue = ChartData.getRoundedToMultiply(maxValue);

                return {
                    0: { ticks: new ChartData.MbGbFormater(roundedMaxValue, 5).formatedTicks() }
                }
            }
        };

        activate();

        function activate() {
            getChartsData();
            $rootScope.$broadcast('ap:loaded');
        }

        // Get data for all charts
        function getChartsData() {
            vm.widgetAvailibity = {};
            vm.mostActiveApsGroupLoaded = false;
            vm.volumesAndSessionsChart.data = getDataForWidgetObjectName(vm.volumesAndSessionsChart.name);
            vm.activityChart.data = getDataForWidgetObjectName(vm.activityChart.name);
            vm.totalUsersWidget.data = getDataForWidgetObjectName(vm.totalUsersWidget.name);
            vm.totalSessionsWidget.data = getDataForWidgetObjectName(vm.totalSessionsWidget.name);
            vm.averageDurationWidget.data = getDataForWidgetObjectName(vm.averageDurationWidget.name);
            vm.facebookConnectWidget.data = getDataForWidgetObjectName(vm.facebookConnectWidget.name);
            vm.twitterConnectWidget.data = getDataForWidgetObjectName(vm.mostPopularFlowWidget.name);
            vm.mostPopularFlowWidget.data = getDataForWidgetObjectName(vm.mostPopularFlowWidget.name);
            vm.mostUsedDeviceWidget.data = getDataForWidgetObjectName(vm.mostUsedDeviceWidget.name);
            vm.peakWidget.data = getDataForWidgetObjectName(vm.peakWidget.name);
            vm.popularLanguageWidget.data = getDataForWidgetObjectName(vm.popularLanguageWidget.name);
            vm.genderChart.data = getDataForWidgetObjectName(vm.genderChart.name);
            vm.ageChart.data = getDataForWidgetObjectName(vm.ageChart.name);
            vm.averageSessionTimeChart.data = getDataForWidgetObjectName(vm.averageSessionTimeChart.name);
            vm.devicesChart.data = getDataForWidgetObjectName(vm.devicesChart.name);
            vm.evolutionOfProfilesChart.data = getDataForWidgetObjectName(vm.evolutionOfProfilesChart.name);
            vm.usersChart.data = getDataForWidgetObjectName(vm.usersChart.name);
            vm.usageOverTimeChart.data = getDataForWidgetObjectName(vm.usageOverTimeChart.name);
            vm.top10LanguagesChart.data = getDataForWidgetObjectName(vm.top10LanguagesChart.name);
            vm.mostPopular10ApsChart.data = getDataForWidgetObjectName(vm.mostPopular10ApsChart.name);
            vm.mostPopular10ApsGroupsChart.data = getDataForWidgetObjectName(vm.mostPopular10ApsGroupsChart.name);
            vm.sessionsStackedPlotChart.data = getDataForWidgetObjectName(vm.sessionsStackedPlotChart.name);
            vm.bandwidthStackedPlotChart.data = getDataForWidgetObjectName(vm.bandwidthStackedPlotChart.name);
            vm.averageSessionBandwidthChart.data = getDataForWidgetObjectName(vm.averageSessionBandwidthChart.name);
            vm.averageSessionPerProfileChart.data = getDataForWidgetObjectName(vm.averageSessionPerProfileChart.name);
            vm.loginMethodChart.data = getDataForWidgetObjectName(vm.loginMethodChart.name);
            vm.deviceBrandChart.data = getDataForWidgetObjectName(vm.deviceBrandChart.name);
            vm.deviceBrowserChart.data = getDataForWidgetObjectName(vm.deviceBrowserChart.name);
            vm.deviceOSChart.data = getDataForWidgetObjectName(vm.deviceOSChart.name);

            ChartData.sendFetchedDataEvent();
        }

        // widgetObject constructors
        function widgetObject(name, data, colors) {
            this.name = name;
            this.data = data;
            this.colors = colors;
        }

        function widgetPlotObject(name, hSlantedText) {
            return {
                name: name,
                pointVisible: false,
                hSlantedText: {
                    present: hSlantedText.present,
                    angle: hSlantedText.angle
                }
            };
        }

        function top10PieChartObject(name, colors) {
            return {
                name: name,
                data: null,
                maxCount: 10,
                colors: ['#29B29B', '#239985', '#54FFE3', '#32686E', '#2D4245', '#151C24', '#1F232B', '#0F2A4A', '#566178', '#8C9AAB', '#78663E', '#2B281F'],
                legend: {
                    custom: true,
                    position: "right",
                    icons: _.times(10, function(){ return 'fa fa-circle' }),
                    dataTypes: ['values', 'percentages']
                }
            }
        }

        function getDataForWidgetObjectName(widgetName) {
            return ChartData.getChartData(widgetName);
        }

        function exportToPng(chartId) {
            if (exportingToPngDisabled()) {
                return false;
            }
            var chart = document.getElementById(chartId);
            var svg = chart.getElementsByTagName('svg')[0];
            var timeRange = timeRangeFromFilters();
            var fileName = 'Activity_chart_' + timeRange.from + '_' + timeRange.to;
            FileExporter.exportSvgToPng(svg, fileName);
        }

        function exportToExcel() {
            if (exportingToExcelDisabled()) {
                return false;
            }
            var timeRange = timeRangeFromFilters();
            var fileName = 'Report_' + timeRange.from + '_' + timeRange.to;
            var spreadsheetObject = new FileExporter.MainSpreadsheedTable(vm.volumesAndSessionsChart.data, vm.usersChart.data);
            spreadsheetObject.exportToXLS(fileName);
        }

        function timeRangeFromFilters() {
            return {
                from: moment(vm.filters.date_from).toDate().toLocaleDateString().replace(/\./g , "-"),
                to: moment(vm.filters.date_to).toDate().toLocaleDateString().replace(/\./g , "-")
            };
        }

        function setWidgetAvailibity(e, widgetName) {
            vm.widgetAvailibity[widgetName] = true;
        }

        function exportingToPngDisabled(){
            return vm.widgetAvailibity['UpDownVolumeAndNewRecurringSessionsPerTimePlot'] ? false : true;
        }

        function exportingToExcelDisabled(){
            return !exportingToPngDisabled() && vm.widgetAvailibity['NewAndRecurringUsersPerTimePlot'] ? false : true;
        }

        function showMostActiveApsGroup(event, ApsGroupName) {
            if(angular.isUndefined(ApsGroupName)) {
                vm.mostActiveApsGroup = '-';
            } else {
                vm.mostActiveApsGroup = ApsGroupName;
            }

            vm.mostActiveApsGroupLoaded = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('socialConnect', socialConnect);

    /** @ngInject */
    function socialConnect() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/socialConnect/socialConnect.html',
            controller: SocialConnectController,
            controllerAs: 'social',
            bindToController: true,
            scope: {
                facebook: '='
            }
        };

        return directive;

        /** @ngInject */
        function SocialConnectController($scope, $timeout) {
            var vm = this;

            $scope.$on('chartData:fetched', resolveData);

            activate();

            function activate() {
                resolveData();
            }

            function resolveData() {
                $timeout(function(){
                    vm.loading = true;
                    vm.facebook.then(function(facebookResponse) {
                        var facebookData = facebookResponse.data;

                        facebookData = isNaN(facebookData) ? 0 : (Number(facebookData) * 100).toFixed(0);

                        vm.resolvedData = facebookData;
                        vm.label = 'Facebook Connect';

                        vm.loading = false;
                        displayValueWithUnit();
                    });
                });
            }

            function displayValueWithUnit() {
                if (vm.resolvedData != null && !/^\s*$/.test(vm.resolvedData) && !angular.isUndefined(vm.resolvedData)) {
                    vm.displayedData = vm.resolvedData + "%";
                } else {
                    vm.displayedData = '-'
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('singleValue', singleValue);

    /** @ngInject */
    function singleValue() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/singleValue/singleValue.html',
            controller: SingleValueController,
            controllerAs: 'value',
            bindToController: true,
            scope: {
                data: '=',
                unit: '@',
                label: '@',
                convertFromSecToMin: '&',
                convertFractionToPercentage: '&'
            }
        };

        return directive;

        /** @ngInject */
        function SingleValueController($scope, $timeout) {
            var vm = this;

            $scope.$on('chartData:fetched', resolveData);

            activate();

            function activate() {
                resolveData();
            }

            function resolveData() {
                $timeout(function(){
                    vm.loading = true;
                    vm.data.then(function(response) {
                        var data = response.data;
                        if (vm.convertFromSecToMin()) {
                            var numberData = parseFloat(data.replace("sec", ''));
                            // converts seconds to minutes
                            data = isNaN(numberData) ? 0 : (numberData / 60).toFixed(0);
                        }

                        if (vm.convertFractionToPercentage()) {
                            data = isNaN(data) ? 0 : (Number(data) * 100).toFixed(0);
                        }
                        
                        vm.resolvedData = data;
                        vm.loading = false;
                        displayValueWithUnit();
                    });
                });
            }

            function displayValueWithUnit() {
                if (vm.resolvedData != null && !/^\s*$/.test(vm.resolvedData) && !angular.isUndefined(vm.resolvedData)) {
                    vm.displayedData = vm.unit ? vm.resolvedData + vm.unit : vm.resolvedData;
                } else {
                    vm.displayedData = '-'
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('NorvaldAnalytics')
        .factory('NetworkApSelectorService', NetworkApSelectorService);

    function NetworkApSelectorService($rootScope) {

        var networkApSelectorService = this;

        networkApSelectorService.activeSelector = {
            all: true,
            network: undefined,
            apGroup: undefined
        };

        var service = {
            getActiveSelector: getActiveSelector,
            setActiveSelector: setActiveSelector,
            getNetworksApsGroups: getNetworksApsGroups,
            setNetworksApGroups: setNetworksApGroups,
            getAllNetworks: getAllNetworks,
            getAllNetworksFilter: getAllNetworksFilter,
            getActiveNetworkFilter: getActiveNetworkFilter,
            getActiveApGroupFilter: getActiveApGroupFilter
        }

        return service;

        function setNetworksApGroups(netsApGroups) {
            networkApSelectorService.networksApGroups = netsApGroups;
        }

        function getNetworksApsGroups() {
            return networkApSelectorService.networksApGroups;
        }

        function getAllNetworks() {
            return _.map(getNetworksApsGroups(), function(network) {
                return network.id;
            })
        }

        function getAllNetworksFilter() {
            if (getActiveSelector().all) {
                return getAllNetworks();
            }
        }

        function getActiveNetworkFilter() {
            if (getActiveSelector().network) {
                return getActiveSelector().network.id;
            }
        }

        function getActiveApGroupFilter() {
            if (getActiveSelector().apGroup) {
                return getActiveSelector().apGroup.id;
            }
        }

        function broadcastActiveSelectorChange() {
            $rootScope.$broadcast("activeNetworksApGroupsSelector:changed");
        }

        function getActiveSelector() {
            return networkApSelectorService.activeSelector;
        }

        function setActiveSelector(all, network, apGroup) {
            networkApSelectorService.activeSelector = {
                all: all,
                network: network,
                apGroup: apGroup
            };
            broadcastActiveSelectorChange();
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('networkApSelector', networkApSelector);

    /** @ngInject */
    function networkApSelector() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/networkApSelector/networkApSelector.html',
            controller: NetworkApSelectorController,
            controllerAs: 'selector',
            bindToController: true,
            scope: {
                filters: '='
            }
        };

        return directive;

        /** @ngInject */
        function NetworkApSelectorController($scope, NetworkApSelectorService, $rootScope, filtersFactory, store) {
            $scope.$on('networksApGroups:fetched', onFetchNetworksApGroupsCallback);
            $scope.$on('filters:changed', preparePeriodInfo);

            var vm = this;

            /**
             *  AccessPoints - settings
             */
            vm.accessPointsText = {
                selectAll: "All",
                selectNone: "None",
                reset: "Reset",
                search: "Search...",
                nothingSelected: "ALL ACCESS POINTS"
            };
            vm.accessPoints = [];

            vm.applyAPChange = applyAPChange;

            activate();

            ////////////////////

            function activate() {
                preparePeriodInfo();
            }

            function onFetchNetworksApGroupsCallback(event, data) {
                setAccessPoints();
            }

            /**
             *  Initialize access points for filters
             */
            function setAccessPoints() {
                vm.accessPoints = filtersFactory.getAPFilters();
                store.set('accessPoints', vm.accessPoints);
            }

            function preparePeriodInfo() {
                if (!vm.filters) {
                    vm.filters = filtersFactory.getFiltersParams();
                }
                var periodName = vm.filters.period ? vm.filters.period.name : null;
                vm.periodInfo = {
                    name: periodName,
                    dateFrom: periodName ? moment(vm.filters.date_from).format('D/M') : moment(vm.filters.date_from).format('D/M/YYYY'),
                    dateTo: periodName ? moment(vm.filters.date_to).format('D/M') : moment(vm.filters.date_to).format('D/M/YYYY')
                }
            }

            function applyAPChange() {
                $rootScope.$broadcast('ap:changed');
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('navbar', navbar);

    /** @ngInject */
    function navbar($state, $http, AuthService)
    {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/navbar/navbar.html',
            controller: NavbarController,
            controllerAs: 'navbar',
            bindToController: true
        };

        return directive;

        /** @ngInject */
        function NavbarController()
        {
            var vm = this;

            vm.collapsed = true;
            vm.username = AuthService.getUsername();
            vm.clientName = AuthService.getClientName();
            vm.logout  = logout;
            vm.gotoAppSelector = gotoAppSelector;

            function logout() {
                AuthService.logout();
            }

            function gotoAppSelector() {
                AuthService.gotoAppSelector();
            }
        }
    }

})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('impersonation', impersonate);

    /** @ngInject */
    function impersonate($state, $http, $rootScope, AuthService, $location)
    {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/impersonation/impersonation.html',
            controller: ImpersonateController,
            controllerAs: 'impersonation'
        };
        //$rootScope.impersonationActive = true;
        return directive;

        /** @ngInject */
        function ImpersonateController()
        {

            var vm = this;
            vm.exitImpersonation = exitImpersonation;
            vm.active = (AuthService.getImpersonatedUser()) ? true : false;
            vm.impersonatedUser = AuthService.getUsername();

            function exitImpersonation()
            {
                AuthService.endImpersonation();
            }

        }
    }

})();

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('mostPopularFlow', mostPopularFlow);

    /** @ngInject */
    function mostPopularFlow() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/mostPopularFlow/mostPopularFlow.html',
            controller: MostPopularFlowController,
            controllerAs: 'mostPopular',
            bindToController: true,
            scope: {
                mostpopularflow: '='
            }
        };

        return directive;

        /** @ngInject */
        function MostPopularFlowController($scope, $timeout) {
            var vm = this;

            $scope.$on('chartData:fetched', resolveData);

            activate();

            function activate() {
                resolveData();
            }

            function resolveData() {
                $timeout(function(){
                    vm.loading = true;
                    vm.mostpopularflow.then(function(mostPopularFlowResponse) {
                        var mostPopularFlowData = mostPopularFlowResponse.data;
                        vm.resolvedData = _.round(mostPopularFlowData[1][0] * 100, 0);
                        vm.label = mostPopularFlowData[0][0];

                        vm.loading = false;
                        displayValueWithUnit();
                    });
                });
            }

            function displayValueWithUnit() {
                if (vm.resolvedData != null && !/^\s*$/.test(vm.resolvedData) && !angular.isUndefined(vm.resolvedData)) {
                    vm.displayedData = vm.resolvedData + "%";
                } else {
                    vm.displayedData = '-'
                }
            }
        }
    }
})();

(function() {
    'use strict';
    angular
        .module('NorvaldAnalytics')
        .factory('filtersFactory', filtersFactory);

    /** @ngInject */
    function filtersFactory($http, CONSTANTS, $q, $rootScope, NetworkApSelectorService) {
        $rootScope.$on('activeNetworksApGroupsSelector:changed', setNetworksAndApGroupsFilters);
        $rootScope.$on('ap:loaded', fetchFilters)

        // Stored filters
        var filtersFactory = this;

        var beginOfCurrentWeek = moment().startOf('isoWeek');
        var endOfCurrentWeek = moment().endOf('isoWeek');

        var filtersCalled = 0;
        var filtersCalledLimit = 100;

        filtersFactory.filters = {};

        filtersFactory.age = {
            min: "0",
            max: "100",
        };

        filtersFactory.filtersParams = {
            "date_from": beginOfCurrentWeek.subtract(1, 'week').format(),
            "date_to": endOfCurrentWeek.subtract(1, 'week').format(),
            "period": { id: 'last_week', name: 'Last week' },
            "gender_type": ["female", "male", "unknown"],
            "age": [filtersFactory.age.min, filtersFactory.age.max],
            "language": [],
            "languages": [],
            "filterAccesspoints": [],
            "network": [],
            "networks": [],
            "accesspoint_group": [],
            "session_time": ["5", "5-30", "30+"],
            "session_bandwidth": ["10MB", "10-100MB", "100MB+"],
            "session_device": ["1", "2-5", "5+"],
            "device_type": ["desktop", "phone", "tablet", "unknown"],
            "device_os": ["android", "ios", "unknown", "windows"]
        };

        // Endpoints
        var filtersUrl = CONSTANTS.BASE_URL + '/api/v1/widget/';

        // Public
        return {
            fetchFilters: fetchFilters,
            getFilters: getFilters,
            getLanguageFilters: getLanguageFilters,
            getAPFilters: getAPFilters,
            setFiltersParams: setFiltersParams,
            getFiltersParams: getFiltersParams,
            getNetworksApGroups: getNetworksApGroups
        };

        //////////////

        /**
         *  Container for fetching filters from API
         */
        function fetchFilters() {
            filtersCalled = 0;
            return downloadFilters().then(function(data) {
                console.log('## Analytics filters loaded')
                setFilters(data);
                $rootScope.$broadcast('networksApGroups:fetched', data.networks);
            });
        }

        /**
         *  Filters object getter
         */
        function getFilters() {
            return filtersFactory.filters;
        }

        /**
         *  Filters object setter
         */
        function setFilters(data) {
            filtersFactory.filters = data;
        }

        /**
         *  Get parsed filters for languages
         */
        function getLanguageFilters() {
            var languageFilters = [];

            var filters = getFilters();

            _.each(filters.filterLanguages, function(group) {
                var groupObject = {
                    name: group.group,
                    msGroup: true
                };

                languageFilters.push(groupObject);

                _.each(group.values, function(language) {
                    languageFilters.push(language);
                });

                languageFilters.push({
                    msGroup: false
                });
            });

            return languageFilters;
        }

        /**
         *  Get parsed filters for access points
         */
        function getAPFilters() {
            var APFilters = [];

            var filters = getFilters();

            _.each(filters.filterAccesspoints, function(group) {
                var groupObject = {
                    name: group.group,
                    msGroup: true
                };

                APFilters.push(groupObject);

                _.each(group.values, function(point) {
                    APFilters.push(_.extend(point, {ticked: false}));
                });

                APFilters.push({
                    msGroup: false
                });
            });

            return APFilters;
        }

        /**
         *  Downloads filters from API
         */
        function downloadFilters() {
            filtersCalled ++;
            return $http.get(filtersUrl)
                .then(function(response) {
                    return response.data;
                })
                .catch(function(error) {
                    if (filtersCalled >= filtersCalledLimit) {
                        return onCatch(error);
                    }
                    onCatch(error);
                    return downloadFilters();
                });
        }

        function onCatch(error) {
            return $q.reject(error);
        }

        function setFiltersParams(filters) {
            filtersFactory.filtersParams = filters;
        }

        function getFiltersParams() {
            return filtersFactory.filtersParams;
        }

        function getNetworksApGroups(){
            return filtersFactory.filters.networks;
        }

        /**
         *  Sets filters for current state of Network/Ap group selector
         */
        function setNetworksAndApGroupsFilters() {
            filtersFactory.filtersParams.network = NetworkApSelectorService.getActiveNetworkFilter() || [];
            filtersFactory.filtersParams.networks = NetworkApSelectorService.getAllNetworksFilter() || [];
            filtersFactory.filtersParams.accesspoint_group = NetworkApSelectorService.getActiveApGroupFilter() || [];
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .directive('analyticsFilters', analyticsFilters);

    /** @ngInject */
    function analyticsFilters() {
        var directive = {
            restrict: 'E',
            templateUrl: 'app/components/filters/filters.html',
            controller: FiltersController,
            controllerAs: 'filters',
            bindToController: true,
            scope: {
                filters: '='
            }
        };

        return directive;

        /** @ngInject */
        function FiltersController(filtersFactory, $rootScope, $scope, toastr, AuthService) {
            $scope.$on('ap:changed', applyFilter);

            var vm = this;

            activate();

            // View model variables
            vm.moreFiltersVisible = false;

            // View model functions
            vm.toggleMore = toggleMore;
            vm.changePeriod = changePeriod;
            vm.applyFilter = applyFilter;
            vm.resetFilter = resetFilter;
            vm.cancelPeriod = cancelPeriod;
            vm.impersonationActive = AuthService.impersonationMode();

            /**
             *  Periods - settings
             */
            vm.periods = [
                {id: 'yesterday', name: 'Yesterday'},
                {id: 'last_week', name: 'Last week'},
                {id: 'last_month', name: 'Last month'},
                {id: 'last_quarter', name: 'Last quarter'}
            ];

            /**
             *  From and to - datepickers
             */
                // Datepicker options
            vm.dateOptions = {
                startingDay: 1,
                showWeeks: false,
                showButtonBar: false
            };

            // Object for storing information about if datepicker should be open
            vm.status = {};

            // Functions that open datepickers
            vm.openDatepickerFrom = function () {
                vm.status.fromOpened = true;
            };
            vm.openDatepickerTo = function () {
                vm.status.toOpened = true;
            };

            /**
             *  Gender - settings
             */
                // Define possible gender types
            vm.gender = ['male', 'female', 'unknown'];

            /**
             *  Language - settings
             */
            vm.languageText = {
                selectAll: "All",
                selectNone: "None",
                reset: "Reset",
                search: "Search...",
                nothingSelected: "LANGUAGE"
            };

            /**
             *  AccessPoints - settings
             */
            vm.accessPointsText = {
                selectAll: "All",
                selectNone: "None",
                reset: "Reset",
                search: "Search...",
                nothingSelected: "ACCESS POINT"
            };

            /**
             * Devices - settings
             */
                // Define possible device types
            vm.devices = [
                {
                    name: 'phone',
                    icon: 'mobile',
                    toolTipText: 'Smartphone'
                },
                {
                    name: 'tablet',
                    icon: 'tablet'
                },
                {
                    name: 'desktop',
                    icon: 'desktop'
                },
                {
                    name: 'unknown',
                    icon: 'question-circle'
                }
            ];

            /**
             * Operating systems - settings
             */
                // Define possible device types
            vm.device_os = [
                {
                    name: 'ios',
                    icon: 'apple',
                    toolTipText: 'iOS'
                },
                {
                    name: 'android',
                    icon: 'android'
                },
                {
                    name: 'windows',
                    icon: 'windows'
                },
                {
                    name: 'unknown',
                    icon: 'question-circle'
                }
            ];

            //////////

            function activate() {
                getFilters();
            }

            /**
             *  Set default filters
             */
            function setFilters() {
                vm.filters = filtersFactory.getFiltersParams();
                vm.age = 'ALL';
                setLanguages();
                setAccessPoints();
            }

            /**
             *  Get data for filters
             */
            function getFilters() {
                setFilters();
                if (_.isEmpty(filtersFactory.getFilters())) {
                    filtersFactory.fetchFilters().then(function () {
                        setFilters();
                        vm.filtersReady = true;
                    });
                } else {
                    vm.filtersReady = true;
                }
            }

            /**
             *  Initialize languages for filters
             */
            function setLanguages() {
                vm.languages = filtersFactory.getLanguageFilters();
            }

            /**
             *  Initialize access points for filters
             */
            function setAccessPoints() {
                vm.accessPoints = filtersFactory.getAPFilters();
            }

            /**
             *  Show more filters
             */
            function toggleMore() {
                vm.moreFiltersVisible = !vm.moreFiltersVisible;
            }

            /**
             *  Change period
             */
            function changePeriod(item) {
                var periodName;

                function periodNameObject(name) {
                    this.name = name == 'week' ? 'isoWeek' : name;
                    this.subtrahend = name;
                }

                switch (item.id) {
                    case 'yesterday':
                        periodName = new periodNameObject('day');
                        break;
                    case 'last_week':
                        periodName = new periodNameObject('week');
                        break;
                    case 'last_month':
                        periodName = new periodNameObject('month');
                        break;
                    case 'last_quarter':
                        periodName = new periodNameObject('quarter');
                        break;
                    }

                    var periodStart = moment().startOf(periodName.name).subtract(1, periodName.subtrahend).format();
                    var periodEnd = moment().subtract(1, periodName.subtrahend).endOf(periodName.name).format();

                    // Set models to proper period
                    vm.filters.date_from = periodStart;
                    vm.filters.date_to = periodEnd;
            }

            function applyFilter() {
                if(vm.filters.date_from != '') {
                    vm.filters.date_from = moment(vm.filters.date_from).format();
                }

                if(vm.filters.date_to != '') {
                    vm.filters.date_to = moment(vm.filters.date_to).format();
                }

                // Discard applaying filters when date range is invalid
                if(new Date(vm.filters.date_from) > new Date(vm.filters.date_to)) {
                    toastr.error('Date has an invalid range. "Date to" field can not be greater than field "Date from".', 'Error');
                    return;
                }

                if (vm.age == '< 18') {
                    vm.filters.age = [0, 17];
                } else if (vm.age == '18 - 21') {
                    vm.filters.age = [ 18, 20];
                } else if (vm.age == '+ 21') {
                    vm.filters.age = [21, 100];
                } else {
                    vm.filters.age = [0, 100];
                }
                filtersFactory.setFiltersParams(vm.filters);

                $scope.$evalAsync(function () {
                    $rootScope.$broadcast('filters:changed');
                });
            }

            /**
             * Reset the filter to the default values
             */
            function resetFilter() {
                function periodNameObject(name) {
                    this.name = name == 'week' ? 'isoWeek' : name;
                    this.subtrahend = name;
                }
                $scope.filters.age = 'ALL';

                $scope.filters.filters.gender_type = ['male', 'female', 'unknown'];
                $scope.filters.filters.device_os = ['ios', 'android', 'windows', 'unknown'];
                $scope.filters.filters.device_type = ['phone', 'tablet', 'desktop', 'unknown'];
                $scope.filters.filters.languages = [];
                for (var i = 0, len = $scope.filters.languages.length; i < len; i++) {
                    $scope.filters.languages[i].ticked = false;
                }
                var periodName = new periodNameObject('week');
                $scope.filters.filters.period = {id: "last_week", name: "Last week"};
                $scope.filters.filters.date_from = moment().startOf(periodName.name).subtract(1, periodName.subtrahend).format();
                $scope.filters.filters.date_to = moment().endOf(periodName.name).subtract(1, periodName.subtrahend).format();
                applyFilter();
            }

            function cancelPeriod(){
                delete vm.filters.period;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .factory('ChartData', ChartData)

    function ChartData($resource, $q, CONSTANTS, $log, $rootScope, filtersFactory) {
        var apiURL = CONSTANTS.BASE_URL + '/api/v1/statistics/getdata/?t='+Date.now();
        var resource = $resource(apiURL, null, {
            'getChartData': {
                method: 'POST'
            }
        });

        return {
            getChartData: getChartData,
            convertToChartDataTable: convertToChartDataTable,
            addPercentageColumnBasingOnLastColumn: addPercentageColumnBasingOnLastColumn,
            sendFetchedDataEvent: sendFetchedDataEvent,
            prepareLegendObjectForChartData: prepareLegendObjectForChartData,
            parseLocationPerformanceData: parseLocationPerformanceData,
            formatHAxisDataForLinearChart: formatHAxisDataForLinearChart
        };

        function getChartData(widgetName) {
            var filters = filtersFactory.getFiltersParams();
            var requestObject = {
                "widgetName": widgetName,
                "filter": filters
            };
            return resource.getChartData(null, requestObject).$promise;
        }

        // Convert data recived from backend to suitable data set for chart
        function convertToChartDataTable(dataArray) {
            return _.map(dataArray[0], function (e, i) {
                dataArray[0][i] = e.toString();
                return _.map(dataArray, function (el) {
                    return el[i];
                });
            });
        }

        function addPercentageColumnBasingOnLastColumn(dataArray) {
            var sum = _.sum(
                _.map(dataArray, function (e) {
                    return e[e.length - 1];
                })
            );

            return _.map(dataArray, function (e) {
                // it rounds to first place after comma
                var prc = (Math.round(e[e.length - 1] / sum * 100 * 10) / 10) || 0;
                e.push(prc + "%");
                return e;
            });
        }

        function prepareLegendObjectForChartData(data) {
            var legendData = {
                defaultData: data
            };

            _.each(data, function (e) {
                legendData[e[0]] = {
                    value: e[1],
                    percentage: e[2]
                }
            });

            return legendData;
        }

        function formatHAxisDataForLinearChart(data, format) {
            var dataValues = data.slice(1, data.length);
            return [data[0]].concat(
                _.map(dataValues, function(el, idx) {
                    return [moment(el[0]).format(format)].concat(el.slice(1, el.length));
                })
            )
        }

        function sendFetchedDataEvent() {
            $rootScope.$broadcast("chartData:fetched");
        }

        /**
         *  Parse data provided by API and transform it into polygons for Google Maps
         */
        function parseLocationPerformanceData(data) {
            // Array of parsed data
            var parsedData = [];

            // Unique ID for polygons
            var index = 1;

            // Find maximum user hours spent in AP
            var maximum = _.max(data, function(item) {
                return item.users;
            });
            maximum = parseInt(maximum.users);

            // Set range for high performance (50% of maximum) - below will be mid performance
            var mediumPerformancerangeBreak = 0.5 * maximum;
            var lowPerformanceRangeBreak = 0.1 * maximum;

            // Iterate over data
            _.forEach(data, function(item) {
                // Time spent on AP
                var timeSpent = parseInt(item.users);

                // Set color based on time spent in AP
                var color;
                if(timeSpent <= lowPerformanceRangeBreak) {
                    // If time equals 0 - AP not active
                    color = 'red';
                } else {
                    if(timeSpent > mediumPerformancerangeBreak) {
                        // High performance
                        color = 'green';
                    } else {
                        // Mid performance
                        color = 'yellow';
                    }
                }

                // Object with information about name of access point and time spent by users
                var apData = new CircleDataObject(item);

                // Create small dot in the center of the circle
                var dot = new CircleObject(index, {
                    latitude: item.lat,
                    longitude: item.lng
                }, 'small', color, apData);

                // Increase index
                ++index;

                // Create big circle around the dot
                var circle = new CircleObject(index, {
                    latitude: item.lat,
                    longitude: item.lng
                }, 'big', color, apData);

                // Increase index
                ++index;

                // Push it to parsed data
                parsedData.push(dot);
                parsedData.push(circle);
            });

            return parsedData;
        }

        // Circle object constructor
        function CircleObject(id, center, size, color, data) {
            var circle = this;

            circle.id = id;
            circle.center = center;
            circle.data = data;

            // Assign radius and fill dependent on color:
            if (color == 'green') {
                // ** Green
                circle.radius = 90;
                circle.fill = {
                    color: '#5cb85b',
                    opacity: 1
                };
            } else if (color == 'red') {
                // ** Red
                circle.radius = 30;
                circle.fill = {
                    color: '#cf1a2c',
                    opacity: 1
                };
            } else {
                // ** Yellow
                circle.radius = 60;
                circle.fill = {
                    color: '#29B29B',
                    opacity: 1
                };
            }

            // Assign radius (and opacity if needed) dependent on size
            if (size == 'big') {
                circle.fill.opacity = 0.2;
                circle.clickable = false;
            } else {
                circle.radius = 7;
                circle.clickable = true;

                // Define click event
                circle.events = {
                    click: function() {
                        // Show popup on click event
                        $rootScope.$broadcast("circlePopup:opened", circle.id);
                    }
                };
            }

            // Set stroke to none
            circle.stroke = {
                weight: 0
            };
        }

        // CircleData object constructor
        function CircleDataObject(item) {
            var circleData = this;
            var seconds = item.users;
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor(seconds / 60);

            circleData.apName = item.name;

            if (hours > 0) {
                circleData.unit = hours == 1 ? 'hour' : 'hours';
                circleData.time = hours;
            } else if (minutes > 0) {
                circleData.unit = minutes == 1 ? 'minute' : 'minutes';
                circleData.time = minutes;
            } else {
                circleData.unit = seconds == 1 ? 'second' : 'seconds';
                 circleData.time = seconds;
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .factory('ChartData', ChartData)

    function ChartData($resource, $q, CONSTANTS, $log, $rootScope, filtersFactory, $queue, store) {
        var apiURL = CONSTANTS.BASE_URL + '/api/v1/statistics/getdata/?t='+Date.now();
        var resource = $resource(apiURL, null, {
            'getChartData': {
                method: 'POST'
            }
        });

        // Options for the queue of requests
        var options = {
            delay: CONSTANTS.REQUEST_DELAY || 100 // delay between requests, in miliseconds
        };

        // Number of concurrent request, means request for which no response has been obtained
        var concurrentRequestsCount = 0;

        // Object represents queue of requests
        var requestQueue = $queue.queue(getWidgetDataCallback, options);

        return {
            getChartData: getChartData,
            convertToChartDataTable: convertToChartDataTable,
            addPercentageColumnBasingOnLastColumn: addPercentageColumnBasingOnLastColumn,
            sendFetchedDataEvent: sendFetchedDataEvent,
            prepareLegendObjectForChartData: prepareLegendObjectForChartData,
            parseLocationPerformanceData: parseLocationPerformanceData,
            formatHAxisDataForLinearChart: formatHAxisDataForLinearChart,
            getRoundedMaximumValueForSeries : getRoundedMaximumValueForSeries,
            getMaximumValueForSeries: getMaximumValueForSeries,
            MbGbFormater : MbGbFormater,
            BGbFormater : BGbFormater,
            replaceNameOfSeries: replaceNameOfSeries,
            parseColumnToDate: parseColumnToDate,
            convertTimeToDateTimeForDayUsage: convertTimeToDateTimeForDayUsage,
            getRoundedToMultiply: getRoundedToMultiply,
            getDecimalRoundedMaximumValueForSeries: getDecimalRoundedMaximumValueForSeries
        };

        function dataInStorageExpired(expireTime) {
            return expireTime && (Date.now() >= expireTime);
        }

        function cachedDataObject(responseData){
            this.response = responseData;

            if (CONSTANTS.CACHE_EXPIRATION_TIME) {
                this.expireTime = Date.now() + 1000*60*CONSTANTS.CACHE_EXPIRATION_TIME;
            }
        }

        function saveResponseObjectInLocalStorage(key, response) {
            var cachedData = new cachedDataObject(response);
            store.set(key, cachedData);
        }

        function  getWidgetDataCallback(params) {
            var key = JSON.stringify(params.requestObject);
            key = key + store.get('auth.username') + '+' + store.get('auth.client-id');
            var cache = store.get(key);

            if (cache && !dataInStorageExpired(cache.expireTime)) {
                return params.deferred.resolve(cache.response);
            }

            var resp = resource.getChartData(null, params.requestObject).$promise;
            concurrentRequestsCount ++;

            resp.then(function(response) {
                saveResponseObjectInLocalStorage(key, response);
                concurrentRequestsCount --;
                if ((concurrentRequestsCount < CONSTANTS.MAX_CONCURRENT_REQUESTS) && requestQueue.paused) {
                    requestQueue.start();
                }
            });

            if (concurrentRequestsCount >= CONSTANTS.MAX_CONCURRENT_REQUESTS) {
                requestQueue.pause();
            }

            params.deferred.resolve(resp);
        };

        function getChartData(widgetName) {
            var filters = filtersFactory.getFiltersParams();
            var requestObject = {
                "widgetName": widgetName,
                "filter": filters
            };
            var deferred = $q.defer();
            requestQueue.add({requestObject: requestObject, deferred: deferred});
            return deferred.promise;
        }

        // Convert data recived from backend to suitable data set for chart
        function convertToChartDataTable(dataArray) {
            return _.map(dataArray[0], function (e, i) {
                dataArray[0][i] = e.toString();
                return _.map(dataArray, function (el) {
                    return el[i];
                });
            });
        }

        function addPercentageColumnBasingOnLastColumn(dataArray) {
            var sum = _.sum(
                _.map(dataArray, function (e) {
                    return e[e.length - 1];
                })
            );

            return _.map(dataArray, function (e) {
                // it rounds to first place after comma
                var prc = (Math.round(e[e.length - 1] / sum * 100 * 10) / 10) || 0;
                e.push(prc + "%");
                return e;
            });
        }

        function prepareLegendObjectForChartData(data) {
            var legendData = {
                defaultData: data
            };

            _.each(data, function (e) {
                legendData[e[0]] = {
                    value: e[1],
                    percentage: e[2]
                }
            });

            return legendData;
        }

        function formatHAxisDataForLinearChart(data, format) {
            var dataValues = data.slice(1, data.length);
            return [data[0]].concat(
                _.map(dataValues, function(el, idx) {
                    return [moment(el[0]).format(format)].concat(el.slice(1, el.length));
                })
            )
        }

        function sendFetchedDataEvent() {
            $rootScope.$broadcast("chartData:fetched");
        }

        /**
         *  Parse data provided by API and transform it into polygons for Google Maps
         */
        function parseLocationPerformanceData(data) {
            // Array of parsed data
            var parsedData = [];

            // Unique ID for polygons
            var index = 1;

            // Find maximum user hours spent in AP
            var maximum = _.max(data, function(item) {
                return item.users;
            });
            maximum = parseInt(maximum.users);

            // Set range for high performance (50% of maximum) - below will be mid performance
            var mediumPerformancerangeBreak = 0.5 * maximum;
            var lowPerformanceRangeBreak = 0.1 * maximum;

            // Iterate over data
            _.forEach(data, function(item) {
                // Time spent on AP
                var timeSpent = parseInt(item.users);

                // Set color based on time spent in AP
                var color;
                if(timeSpent <= lowPerformanceRangeBreak) {
                    // If time equals 0 - AP not active
                    color = 'red';
                } else {
                    if(timeSpent > mediumPerformancerangeBreak) {
                        // High performance
                        color = 'green';
                    } else {
                        // Mid performance
                        color = 'yellow';
                    }
                }

                // Object with information about name of access point and time spent by users
                var apData = new CircleDataObject(item);

                // Create small dot in the center of the circle
                var dot = new CircleObject(index, {
                    latitude: item.lat,
                    longitude: item.lng
                }, 'small', color, apData);

                // Increase index
                ++index;

                // Create big circle around the dot
                var circle = new CircleObject(index, {
                    latitude: item.lat,
                    longitude: item.lng
                }, 'big', color, apData);

                // Increase index
                ++index;

                // Push it to parsed data
                parsedData.push(dot);
                parsedData.push(circle);
            });

            return parsedData;
        }

        // Circle object constructor
        function CircleObject(id, center, size, color, data) {
            var circle = this;

            circle.id = id;
            circle.center = center;
            circle.data = data;

            // Assign radius and fill dependent on color:
            if (color == 'green') {
                // ** Green
                circle.radius = 90;
                circle.fill = {
                    color: '#5cb85b',
                    opacity: 1
                };
            } else if (color == 'red') {
                // ** Red
                circle.radius = 30;
                circle.fill = {
                    color: '#cf1a2c',
                    opacity: 1
                };
            } else {
                // ** Yellow
                circle.radius = 60;
                circle.fill = {
                    color: '#29B29B',
                    opacity: 1
                };
            }

            // Assign radius (and opacity if needed) dependent on size
            if (size == 'big') {
                circle.fill.opacity = 0.2;
                circle.clickable = false;
            } else {
                circle.radius = 7;
                circle.clickable = true;

                // Define click event
                circle.events = {
                    click: function() {
                        // Show popup on click event
                        $rootScope.$broadcast("circlePopup:opened", circle.id);
                    }
                };
            }

            // Set stroke to none
            circle.stroke = {
                weight: 0
            };
        }

        // CircleData object constructor
        function CircleDataObject(item) {
            var circleData = this;
            var seconds = item.users;
            var hours = Math.floor(seconds / 3600);
            var minutes = Math.floor(seconds / 60);

            circleData.apName = item.name;

            if (hours > 0) {
                circleData.unit = hours == 1 ? 'hour' : 'hours';
                circleData.time = hours;
            } else if (minutes > 0) {
                circleData.unit = minutes == 1 ? 'minute' : 'minutes';
                circleData.time = minutes;
            } else {
                circleData.unit = seconds == 1 ? 'second' : 'seconds';
                 circleData.time = seconds;
            }
        }


        /*
         * Gets maximum value for specified series
         * @param {Array} dataArray - Two dimensional array with data for chart, first row contains column names
         * @param {Array of Number} series - Indexes of series in chart data array
         * return maximum value in series
         */
        function getMaximumValueForSeries(dataArray, series) {
            var dataWithoutSeriesName = dataArray.slice(1, dataArray.length);
            var dataForSeries =_.map(dataWithoutSeriesName, function(array){
                return _.map(series, function(el){ return array[el]});
            });

            return _.max(_.flatten(dataForSeries));
        }

        /*
         * Gets maximum value for specified series rounded to specified places before comma
         * @param {Array} dataArray - Two dimensional array with data for chart, first row contains column names
         * @param {Array of Number} series - Indexes of series in chart data array
         * @param {Number} placeBeforeComma - number of places before comma to round
         * return maximum value rounded to places before comma
         */
        function getRoundedMaximumValueForSeries(dataArray, series, placesBeforeComma) {
            var max = getMaximumValueForSeries(dataArray, series);
            var roundedPart = Math.ceil(max / Math.pow(10, 2));
            return Number(roundedPart + _.repeat('0', placesBeforeComma));
        }

        /*
         * Gets maximum value for specified series rounded to decimal digit
         * @param {Array} dataArray - Two dimensional array with data for chart, first row contains column names
         * @param {Array of Number} series - Indexes of series in chart data array
         * return maximum value rounded
         */
        function getDecimalRoundedMaximumValueForSeries(dataArray, series) {
            var max = getMaximumValueForSeries(dataArray, series);

            if(max < Math.pow(10, 6)) {
                return max;
            }
            return Math.ceil(max / Math.pow(10, 2));
        }

        // Mega Bytes / Giga Bytes formater constructor
        function MbGbFormater(maxValue, stepsCount) {
            this.maxValue = maxValue;
            this.stepsCount = stepsCount;
            var _this = this;

            // Returns proper formated value in MB or GB for vAxis specified by stepNumber
            this.format = function(stepNumber, value) {
                if (stepNumber == 0) {
                    return 0;
                } else if (value >= 1024 && value < Math.pow(1024, 2)) {
                    return  Math.ceil(value / 1024 * 100) / 100 + ' GB';
                } else if (value >= Math.pow(1024, 2) && value < Math.pow(1024, 3)) {
                    return  Math.ceil(value / Math.pow(1024, 2) * 100) / 100 + ' TB';
                } else if(value >= Math.pow(1024, 3)) {
                    return  Math.ceil(value / Math.pow(1024, 3) * 100) / 100 + ' PB';
                }
                return value + ' MB';
            };

            // Returns value for vAxis specified by stepNumber
            this.stepValue = function(stepNumber, stepRange) {
                if (stepNumber == 0) { return 0; }
                return Math.ceil(stepNumber * stepRange * 100) / 100;
            };

            // Caltulates range between vAxes
            this.stepRange = function (stepsCount, maxValue) {
                return Math.ceil(maxValue / (stepsCount - 1));
            };

            // Returns array of objects required by google chart for formating axes values
            this.formatedTicks = function() {
                var stepRange = this.stepRange(this.stepsCount, this.maxValue);
                var _this = this;

                return _.times(this.stepsCount, function(idx) {
                    var stepValue = _this.stepValue(idx, stepRange);
                    return {
                        v: stepValue,
                        f: _this.format(idx, stepValue)
                    };
                });
            }
        }

        // Bytes / Giga Bytes formater constructor
        function BGbFormater(maxValue, stepsCount) {
            this.maxValue = maxValue;
            this.stepsCount = stepsCount;
            var _this = this;

            // Returns proper formated value in MB or GB for vAxis specified by stepNumber
            this.format = function(stepNumber, value) {
                if (stepNumber == 0) {
                    return 0;
                } else if (value >= 1024 && value < Math.pow(1024, 2)) {
                    return  Math.ceil(value / 1024 * 100) / 100 + ' KB';
                } else if (value >= Math.pow(1024, 2) && value < Math.pow(1024, 3)) {
                    return  Math.ceil(value / Math.pow(1024, 2) * 100) / 100 + ' MB';
                } else if(value >= Math.pow(1024, 3)) {
                    return  Math.ceil(value / Math.pow(1024, 3) * 100) / 100 + ' GB';
                }
                return value + ' B';
            };

            // Returns value for vAxis specified by stepNumber
            this.stepValue = function(stepNumber, stepRange) {
                if (stepNumber == 0) { return 0; }
                return Math.ceil(stepNumber * stepRange * 100) / 100;
            };

            // Caltulates range between vAxes
            this.stepRange = function (stepsCount, maxValue) {
                return Math.ceil(maxValue / (stepsCount - 1));
            };

            // Returns array of objects required by google chart for formating axes values
            this.formatedTicks = function() {
                var stepRange = this.stepRange(this.stepsCount, this.maxValue);
                var _this = this;

                return _.times(this.stepsCount, function(idx) {
                    var stepValue = _this.stepValue(idx, stepRange);
                    return {
                        v: stepValue,
                        f: _this.format(idx, stepValue)
                    };
                });
            }
        }

        // Replaces names of series specified by number of column in dataArray
        function replaceNameOfSeries(dataArray, objectOfNames) {
            _.map(objectOfNames, function(el, idx){
                dataArray[0][idx] = el;
            });

            return dataArray;
        }

        // Converts datetime in string to datetime object
        function parseColumnToDate(columnIdx, arrayOfData) {
            return _.map(arrayOfData, function(row, idx) {
                if (idx == 0){
                    return row;
                } else {
                    row[columnIdx] = new Date(row[columnIdx]);
                    return row;
                }
            });
        }

        function convertTimeToDateTimeForDayUsage(data) {
            var header = data.slice(0,1);
            var dataPart = data.slice(1, data.lenght);
            var dataArray = _.map(dataPart, function(e){
                var timeArray = e[0].split(':');
                var timeArrayInt = _.map(timeArray, function(e) { return parseInt(e)} );
                var today = new Date();
                today.setHours(timeArrayInt[0], timeArrayInt[1], timeArrayInt[2]);
                return [today.toISOString(), e[1]];
            });
            dataArray = _.sortBy(dataArray, function(element){ return element[0]; });
            return header.concat(dataArray);
        }

        function getRoundedToMultiply(number) {
            var multiplyValue;

            if(!number) {
                return 0;
            } else if (number < 1024) {
                // < 1GB
                multiplyValue = 100;
            } else if (number >= 1024 && number < Math.pow(1024, 2)) {
                // 1GB - 1TB
                multiplyValue =  1024 * 5;
            } else if (number >= Math.pow(1024, 2) && number < Math.pow(1024, 3)) {
                // 1TB - 1PB
                multiplyValue = Math.pow(1024, 2) * 5;
            } else if (number >= Math.pow(1024, 3)) {
                // > 1PB
                multiplyValue = Math.pow(1024, 3) * 5;
            }

            return multiplyValue * Math.ceil(number / multiplyValue);
        }
    }
})();

'use strict';

angular
	.module('NorvaldAnalytics')
	.filter('thousandSeparator', ThousandSeparator)

function ThousandSeparator() {
	return function(input) {
		if(angular.isUndefined(input)) {
			return input
		}
		
		return input.toString()
    		.replace('.', ',')
			.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.");
  	};  	

}
(function () {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .factory('FileExporter', FileExporter)

        function FileExporter($filter, $q){

            return {
                exportSvgToPng       : exportSvgToPng,
                MainSpreadsheedTable : MainSpreadsheedTable
            }

            /**
             * Exports SVG DOM element to png file, svg object before exporting is converting to canvas
             * @param svgData Information about SVG element
             * @param svgNode SVG DOM node
             * @param {String} filename Filename for png file
             */
            function exportSvgToPng(svgNode, filename) {
                //setting width and height for svg element is required for proper scalling by canvg
                var increasedWidth = svgNode.width.baseVal.value * 2;
                var increasedHeight = svgNode.height.baseVal.value * 2
                svgNode.setAttribute('width', increasedWidth);
                svgNode.setAttribute('height', increasedHeight);
                var svgString = new XMLSerializer().serializeToString(svgNode);
                var canvasElement = document.createElement("CANVAS");
                canvg(canvasElement, svgString, { scaleWidth: increasedWidth*2, scaleHeight: increasedHeight*2});

                // For FF and Chrome v>=50
                if (typeof canvasElement.toBlob !== "undefined") {
                    canvasElement.toBlob(function(blob) {
                        saveAs(blob, filename + ".png");
                    });
                }

                // For IE v>=10
                else if (typeof canvasElement.msToBlob !== "undefined") {
                    saveAs(canvasElement.msToBlob(), filename + ".png");
                }

                // For Safari and Chrome v<50
                else {
                    var dataURL = canvasElement.toDataURL('image/jpeg');
                    var blob = dataURItoBlob(dataURL);
                    saveAs(blob, filename + ".png");
                }
            }

            //http://stackoverflow.com/questions/4998908/convert-data-uri-to-file-then-append-to-formdata
            /**
             * Converts image data to blob
             * @param {String} dataURI Data in base64
             */
            function dataURItoBlob(dataURI) {
                // convert base64/URLEncoded data component to raw binary data held in a string
                var byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0)
                    byteString = atob(dataURI.split(',')[1]);
                else {
                    byteString = unescape(dataURI.split(',')[1]);
                }
                // separate out the mime component
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

                // write the bytes of the string to a typed array
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }

                return new Blob([ia], {type:mimeString});
            }



            function MainSpreadsheedTable(volumesAndSessionsData, usersData) {
                var _this = this;
                var volumesAndSesionsResolvedDefered = $q.defer();
                var usersDefered = $q.defer();
                this.volumesAndSessionsData = volumesAndSessionsData;
                this.usersData = usersData;
                this.dates = [];
                this.volumeDownloaded = {};
                this.volumeUploaded = {};
                this.newSessions = {};
                this.recurrentSessions = {};
                this.newUsers = {};
                this.recurrentUsers = {};
                this.volumesAndSesionsResolved = volumesAndSesionsResolvedDefered.promise;
                this.usersResolved = usersDefered.promise;
                this.tHeadColStyle = 'background-color: #444D52; color: white; font-weight: bold; text-align: left'
                this.dateColStyle = 'text-align: right; background-color: #E6BB4F;'
                this.colStyle = 'text-align: right;'
                this.tFootStyle = 'text-align: right; background-color: #BFBFBF; font-weight: bold';
                this.headers = ['Date', 'Volume Up (Mb)', 'Volume Down (Mb)', 'New User (#)', 'Recurrent User (#)', 'New Session (#)', 'Recurrent Session (#)'];

                // methods
                this.getArrayOfValues = getArrayOfValues;
                this.drawTable = drawTable;
                this.promisesResolved = promisesResolved;
                this.sumarize = sumarize;
                this.exportToXLS = exportToXLS;

                activate();

                function activate() {
                    // prepares table columns for data fetched for "volumes uploaded/downloaded and new/recurrent sessions" widget
                    _this.volumesAndSessionsData.then(function(resolvedData) {
                        _this.volumesAndSessionsData = resolvedData.data.slice(1, resolvedData.data.length);

                        _.forEach(_this.volumesAndSessionsData, function(row, idx) {
                            _this.dates.push(row[0])
                            var downloaded = row[3] / (1024*1024); // Convert bytes to megabytes
                            var uploaded = row[4] / (1024*1024);   // Convert bytes to megabytes
                            _this.volumeDownloaded[row[0]]  = parseFloat(downloaded.toFixed(2));
                            _this.volumeUploaded[row[0]]    = parseFloat(uploaded.toFixed(2));
                            _this.newSessions[row[0]]       = row[2];
                            _this.recurrentSessions[row[0]] = row[1];
                        });
                        volumesAndSesionsResolvedDefered.resolve(true);
                    });

                    // prepares table columns for data fetched for "new/recurrent users" widget
                    _this.usersData.then(function(resolvedData) {
                        _this.usersData = resolvedData.data.slice(1, resolvedData.data.length);
                        _.forEach(_this.usersData, function(row, idx) {
                            _this.newUsers[row[0]]        = row[2];
                            _this.recurrentUsers[row[0]]  = row[1];
                        });
                        usersDefered.resolve(true);
                    });
                }

                // returns promise which will be resolved when data for spreadsheet will be resolved
                function promisesResolved() {
                    var defered = $q.defer();
                    this.volumesAndSesionsResolved.then(function() {
                        _this.usersResolved.then(function() {
                            defered.resolve(true);
                        });
                    });
                    return defered.promise;
                }

                // returns row for specified date
                function getArrayOfValues() {
                    return _.map(this.dates, function(date){
                        var row = [];
                        row[0] = moment(date).format('DD/MM/YY')+"\u00A0"; // Empty char added at the end because otherwise MS Excel parses it to date with incorrect format
                        row[1] = $filter('thousandSeparator')(_this.volumeUploaded[date]);
                        row[2] = $filter('thousandSeparator')(_this.volumeDownloaded[date]);
                        row[3] = $filter('thousandSeparator')(_this.newUsers[date]);
                        row[4] = $filter('thousandSeparator')(_this.recurrentUsers[date]);
                        row[5] = $filter('thousandSeparator')(_this.newSessions[date]);
                        row[6] = $filter('thousandSeparator')(_this.recurrentSessions[date]);
                        return row;
                    });
                }

                // sums values in the spreadsheet
                function sumarize(columnType) {
                    function sumColumn(columnObject) {
                        return _.reduce(columnObject, function(sum, el){
                            return sum + el;
                        });
                    }

                    switch(columnType) {
                        case 'volumeDownloaded':
                            return sumColumn(this.volumeDownloaded).toFixed(2);
                        case 'volumeUploaded':
                            return sumColumn(this.volumeUploaded).toFixed(2);
                        case 'newSessions':
                            return sumColumn(this.newSessions);
                        case 'recurrentSessions':
                            return sumColumn(this.recurrentSessions);
                        case 'newUsers':
                            return sumColumn(this.newUsers);
                        case 'recurrentUsers':
                            return sumColumn(this.recurrentUsers);
                    }
                }

                // returns complete html array for the spreadsheet
                function drawTable() {
                    var table = document.createElement('TABLE');
                    var tHead = table.createTHead(0);
                    var tHeadRow = tHead.insertRow(0);

                    // Fills table head
                    _.map(this.headers, function(header, idx){
                        var cell = tHeadRow.insertCell(idx);
                        cell.setAttribute('style', _this.tHeadColStyle);
                        cell.innerHTML = header;
                    });

                    // Fills table body
                    var spreadsheetArray = _this.getArrayOfValues();
                    _.forEach(spreadsheetArray, function(row, rIdx) {
                        var tRow = table.insertRow(rIdx + 1);
                        _.forEach(row, function(col, cIdx) {
                            var tCell = tRow.insertCell(cIdx);
                            tCell.setAttribute('style', _this.colStyle);
                            if(cIdx == 0){
                                tCell.setAttribute('style', _this.dateColStyle);
                            }
                            tCell.innerHTML = col;
                        });
                    });

                    // Fills table foot with sumarized values
                    var tFoot = table.createTFoot();
                    var tFRow = tFoot.insertRow(0);
                    _.forEach(_this.headers, function(el, idx) {
                        var tFCell = tFRow.insertCell(idx);
                        var tFCellValue;
                        switch(idx) {
                            case 0:
                                tFCellValue = 'Grand Total';
                                break;
                            case 1:
                                tFCellValue = _this.sumarize('volumeUploaded');
                                break;
                            case 2:
                                tFCellValue = _this.sumarize('volumeDownloaded');
                                break;
                            case 3:
                                tFCellValue = _this.sumarize('newUsers');
                                break;
                            case 4:
                                tFCellValue = _this.sumarize('recurrentUsers');
                                break;
                            case 5:
                                tFCellValue = _this.sumarize('newSessions');
                                break;
                            case 6:
                                tFCellValue = _this.sumarize('recurrentSessions');
                                break;
                        }
                        tFCell.innerHTML = tFCellValue;
                        tFCell.setAttribute('style', _this.tFootStyle);
                    });
                    return table;
                }

                // exports html table to XLS file
                function exportToXLS(filename) {
                    // when all promised are resolved
                    this.promisesResolved().then(function() {
                        var htmlTable = _this.drawTable();
                        var blob = new Blob([htmlTable.outerHTML], {
                            type: "vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                        });
                        saveAs(blob, filename + ".xls");
                    });
                }
            }
        }
})();

'use strict';

angular
    .module('NorvaldAnalytics')
    .factory('AuthService', AuthService)

function AuthService($http, store, CONSTANTS, $rootScope, $location) {
    var loginUrl = CONSTANTS.BASE_URL + '/api/v1/login';
    var statusUrl = CONSTANTS.CORE_API_URL + 'user/status';

    var service = {
        login: login,
        logout: logout,
        userIsLogged: userIsLogged,
        setAccessToken: setAccessToken,
        getAccessToken: getAccessToken,
        getTokenHeader: getTokenHeader,
        setUsername: setUsername,
        getUsername: getUsername,
        getClientName: getClientName,
        getClientId: getClientId,
        setClientId: setClientId,
        getNetworks: getNetworks,
        setNetworks: setNetworks,
        delegatedLogin: delegatedLogin,
        setImpersonation: setImpersonation,
        getImpersonatedUser: getImpersonatedUser,
        endImpersonation: endImpersonation,
        impersonationMode: impersonationMode,
        gotoAppSelector: gotoAppSelector,
        clearData: clearData,
        createQuery: createQuery,
        getStatus: getStatus,
        authenticate: authenticate
    }

    return service;

    /**
     * clear auth data
     */
    function clearData()
    {
        /** @todo is this needed, breaks logout/gotoapselector */
        store.remove('auth.X-Access-Token');
        store.remove('auth.username');
        store.remove('auth.client-id');
        store.remove('auth.impersonatedUser');
        store.remove('auth.created_at');
    }

    function createQuery($sendToken)
    {
        if ($sendToken === true)  {
            var query = '?token=' + window.btoa(getAccessToken()) + '&identifier=' + getClientId();
        } else {
            var query = '?identifier=' + getClientId();
        }
        if (impersonationMode()) {
            query += '&impersonate=' + encodeURIComponent(getImpersonatedUser());
        }
        return query;
    }

    function authenticate () {
        return new Promise(function (resolve, reject) {
            if (typeof $location.search()['token'] !== 'undefined') {
                // we have a new token given
                // let's get our auth details
                var token = $location.search()['token'];
                var newAccessToken = window.atob(token);
                var clientId = $location.search()['identifier'];
                var impersonatee = false;

                console.info('## Analytics Auth ## NEW TOKEN ' + newAccessToken)
                setAccessToken(newAccessToken);
                if (typeof $location.search().impersonate !== 'undefined') {
                    impersonatee = decodeURIComponent($location.search().impersonate);
                    setImpersonation(impersonatee);
                    console.info('## Analytics Auth ## Impersonate ' + impersonatee)
                } else {
                    setImpersonation();
                }
                var data = {
                    clientId: clientId
                };
                var req = {
                    'method': 'POST',
                    'url': loginUrl,
                    'headers': {
                        'X-WSSE': getTokenHeader(getAccessToken())
                    },
                    data: data
                }

                // if(req.headers.X-WSSE)
                
                try {
                    $http(req).then(function(response) {
                        setUsername(response.data.user.firstname + ' ' + response.data.user.lastname)
                        if (('' + response.data.user.firstname + response.data.user.lastname)=='') {
                            setUsername(response.data.user.username)
                        }
                    
                        setClientId(response.data.client.id);
                        setClientName(response.data.client.name);
                        setNetworks(response.data.networks);
                        if (response.status === 200) {
                            resolve(2)
                        } else if (response.error === 'Not authorized') {
                            reject('No Client specified')
                        } else {
                            reject('No valid usertoken')
                        }
                    });
                } catch (error) {
                    reject(error);
                }
                
            } else if (userIsLogged()) {
                // no token given, but old token not expired
                // let's get the status of the token
                console.info('## Analytics Auth ## valid client-side token')
                var req = {
                    'method': 'POST',
                    'url': statusUrl,
                    'headers': {
                        'Authorization': 'WSSE profile="UsernameToken"',
                        'X-WSSE': getTokenHeader(getAccessToken())
                    },
                    data: []
                }
                return $http(req).then(function(response) {
                    if (response.data.message === 'Authenticated') {
                        console.info('## Analytics Auth ## valid status')
                        resolve(1)
                    } else {
                        console.error('## Analytics Auth ## invalid status')
                        reject('Invalid session')
                    }
                });
            } else {
                console.error('## Analytics Auth ## invalid token no token param')
                reject('Invalid session')
            }
        });
    }

    /**
     * superseded by delegated login
     * @param {@depcrated} user
     */
    function login(user) {
        var data = {
            _username: user.username,
            _password: user.password
        };

        return $http.post(loginUrl, data).then(function(response) {
            setAccessToken(response.data.token);
            setUsername(response.data.user.firstname + ' ' + response.data.user.lastname);
            if (('' + response.data.user.firstname + response.data.user.lastname)=='') {
                setUsername(response.data.user.username)
            }
            setClientId(response.data.client.id);
            setNetworks(response.data.networks);
            setImpersonation();
            return response.data.success;
        });
    };

    function getStatus() {
        if (!userIsLogged()) {
            return false;
        }
        var accessToken = getAccessToken();
        var req = {
            'method': 'POST',
            'url': statusUrl,
            'headers': {
                'Authorization': 'WSSE profile="UsernameToken"',
                'X-WSSE': this.getTokenHeader(accessToken)
            },
            data: []
        }
        return $http(req).then(function(response) {
            if (response.data.message === 'Authenticated') {
                return true;
            }
            console.error('Not authenticated');
            window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?errorMessage=' + 'Invalid session' + '&app=' + CONSTANTS.APP_IDENTIFIER;
            this.clearData();
            return false;
        });
    }

    /**
     * Login initiated from outside app
     * @param {string} token
     * @param {string} clientId
     */
    function delegatedLogin(token, clientId) {
        // assume this is a new auth attempt
        this.clearData();
        // decode
        var accessToken = window.atob(token);
        var impersonatee = false;
        var vm = this;
        if (typeof $location.search().impersonate !== 'undefined') {
            impersonatee = decodeURIComponent($location.search().impersonate);
            setImpersonation(impersonatee);
            console.info('## Analytics Auth ## Impersonate ' + impersonatee)
        } else {
            setImpersonation();
        }
        var data = {
            clientId: clientId
        };
        var req = {
            'method': 'POST',
            'url': loginUrl,
            'headers': {
                'X-WSSE': vm.getTokenHeader(accessToken)
            },
            data: data
        }
        return $http(req).then(function(response) {
            setAccessToken(accessToken);
            setUsername(response.data.user.firstname + ' ' + response.data.user.lastname);
            if (('' + response.data.user.firstname + response.data.user.lastname)=='') {
                setUsername(response.data.user.username)
            }
            setClientId(response.data.client.id);
            setClientName(response.data.client.name);
            setNetworks(response.data.networks);
            setImpersonation(impersonatee);
            return response.data.success;
        });
    }

    /**
     * Go to app-selector logout
     */
    function logout() {
        var vm = this;
        var gotoLoc = CONSTANTS.LOGIN_APP_URL + '/logout' + createQuery();
        window.open(gotoLoc, "_self");
    }

    /**
     * go to app selector
     */
    function gotoAppSelector(message) {
        var gotoLoc = CONSTANTS.LOGIN_APP_URL + '/app-selector' + createQuery(true);
        if (typeof message == 'string') {
            gotoLoc += ' ' + message;
        }
        window.open(gotoLoc, "_self");
    }

    /**
     * checks if an user is logged in
     * when token is stored
     * and token is not too old
     */
    function userIsLogged() {
        var now = Date.now();
        // token is long expired
        var expireTime = getLoginTime() + 10800000;
        if (!getAccessToken()) {
            return false;
        } else {
            if (now > expireTime) {
                return false;
            }
            return true;
        }
    }

    /**
     * save access token to store
     * @param {string} token
     */
    function setAccessToken(token) {
        store.set('auth.X-Access-Token', token);
        setLoginTime();
    }

    /**
     * retrieve access token
     */
    function getAccessToken() {
        return store.get('auth.X-Access-Token');
    }

    /**
     * get token for header
     */
    function getTokenHeader(token) {
        return ((token) ? token : getAccessToken()) + ((getImpersonatedUser() !== 'undefined' && (getImpersonatedUser())) ? ', Impersonate="' + getImpersonatedUser() + '"' : '');
    }

    /**
     * set username in store
     *
     * @param {string} username
     */
    function setUsername(username) {
        store.set('auth.username', username);
    }

    /**
     * retrieve username
     */
    function getUsername() {
        return store.get('auth.username');
    }

    function getClientName() {
        return store.get('auth.client-name');
    }

    function setClientName(name) {
        store.set('auth.client-name', name);
    }

    /**
     * Set client-id logged in user in store
     * @param {string} clientId
     */
    function setClientId(clientId) {
        store.set('auth.client-id', clientId);
    }

    /**
     * retrieve client-id from store
     */
    function getClientId() {
        return store.get('auth.client-id');
    }

    /**
     * Set visible networks for user in store
     * @param {Array} networks
     */
    function setNetworks(networks) {
        store.set('networks', networks);
    }

    /**
     * retrieve networks from store
     */
    function getNetworks()
    {
        return store.get('networks');
    }

    /**
     * set which user is impersonated in store
     * @param {string} userName
     */
    function setImpersonation(userName)
    {
        store.set('auth.impersonatedUser', userName);
    }

    /**
     * retrieve which user is impersonated from store
     */
    function getImpersonatedUser()
    {
        return store.get('auth.impersonatedUser');
    }

    /**
     * check if impersonating
     */
    function impersonationMode()
    {
        if (getImpersonatedUser() == 'undefined') {
            return false;
        }

        if (getImpersonatedUser() == false) {
            return false;
        }

        if (getImpersonatedUser()) {
            return true;
        }

        return false
    }

    /**
     * end impersonation and go to app-selector
     */
    function endImpersonation()
    {
        var gotoLoc = CONSTANTS.LOGIN_APP_URL + '/end-impersonation' + createQuery(true);
        setImpersonation();
        window.location = gotoLoc;
    }

    /**
     * set when user logged in to store
     */
    function setLoginTime()
    {
        store.set('auth.created_at', Date.now());
    }

    /**
     * retrieve when user logged in from store
     */
    function getLoginTime()
    {
        return store.get('auth.created_at');
    }
}

(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $state, $httpBackend, CONSTANTS, $location, $injector) {
        // this is evil
        $rootScope.$on('$stateChangeStart', function(event, newState) {
            var AuthService = $injector.get('AuthService');
            AuthService.authenticate().then(function (response) {
                // promise succeeded, go to state
                console.log('## Analytics Auth ## response: ' + response);
                if (response === 2) {
                    event.preventDefault();
                    $state.go('analytics');
                }
            }, function (error) {
                // promise rejected return to auth app
                if(error === 'Invalid session'){
                    window.location = CONSTANTS.LOGIN_APP_URL + '?app=analytics';
                } else {
                    window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?errorMessage=' + error;
                }
                
            });


            // legacy redirecting
            var loggedIn = AuthService.userIsLogged();
            if (!loggedIn && (newState.name != 'login' && newState.name != 'delegatedLogin')) {
                event.preventDefault();
                window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?errorMessage=' + 'Invalid session';
            } else if (loggedIn && (newState.name == 'login')) {
                event.preventDefault();
                $state.go('analytics');
            }
            if (newState.name == 'login' && $location.path !== '/auth' && !loggedIn) {
                window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?app=' + CONSTANTS.APP_IDENTIFIER + '&errorMessage=' + 'Deprecated authentication used';
                event.preventDefault();
            }
        });
        // TODO - Following mechanism to mocking API responses should be removed when all endpoints will fully
        // supported via API
        var allowedData = function(data) {
            var dataJson = JSON.parse(data);
            switch (dataJson.widgetName) {
                case 'DistributionOfGenderBar':
                case 'DistributionByAgeHistogram':
                case 'AvgSessionTimeBar':
                case 'TotalUsersNumber':
                case 'EvolutionOfProfilesChart':
                case 'DistributionOfDeviceTypesTable':
                case 'TopLanguagesTable':
                case 'TopApsTable':
                case 'TopApsGroupsTable':
                case 'SesionPerTimePlot':
                case 'BandwidthPlot':
                case 'AvgSessionBandwidthBar':
                case 'AvgSessionPerProfileBar':
                case 'LoginMethodChart':
                case 'DistributionOfDeviceBrandsTable':
                case 'DistributionOfDeviceBrowsersTable':
                case 'TimeSpentOnApMap':
                case 'DistributionOfDeviceOsTable':
                case 'PopularLanguageName':
                case 'PeakNumber':
                case 'MostUsedDeviceName':
                case 'FacebookConnectNumber':
                case 'TwitterConnectNumber':
                case 'AverageDurationNumber':
                case 'TotalSessionsNumber':
                case 'TotalUsersCounted':
                case 'MostPopularFlow':
                case 'UsersAndSessionsActivityPerTimePlot':
                case 'UpDownVolumeAndNewRecurringSessionsPerTimePlot':
                case 'NewAndRecurringUsersPerTimePlot':
                case 'UsageOverTimeOfDayPlot':
                case 'HeatMapData':
                    return true
            }
            return false
        };

        var notAllowedData = function(data) {
            var dataJson = JSON.parse(data);
            // switch (dataJson.widgetName) {
            //     case 'HeatMapData':
            //         return true
            // }
            return false
        };

        // MOCKS to delete after connect with real api =====================================
        $httpBackend.whenGET(new RegExp(CONSTANTS.CORE_API_URL + ".+")).passThrough();
        $httpBackend.whenPOST(new RegExp(CONSTANTS.CORE_API_URL + ".+")).passThrough();
        var urlPattern = new RegExp(CONSTANTS.BASE_URL + '/api/v1/statistics/getdata/' + "[^+]{0,1}" );
        $httpBackend.whenPOST(CONSTANTS.BASE_URL + "/api/v1/login").passThrough();
        $httpBackend.whenGET(/pages|components\/.*/).passThrough();
        $httpBackend.whenGET(CONSTANTS.BASE_URL + "/api/v1/widget/").passThrough();
        $httpBackend.whenPOST(urlPattern, allowedData).passThrough();
        $httpBackend.whenPOST(CONSTANTS.BASE_URL + "/api/v1/statistics/getrawdata/").passThrough();
        $httpBackend.whenPOST(CONSTANTS.BASE_URL + "/api/v1/statistics/downloadrawdata/").passThrough();
        $httpBackend.whenPOST(urlPattern, notAllowedData)
            .respond(function(method, url, data) {

                var responseData = {
                    success: true,
                    data: prepareResponseData(data)
                };

                return [200, responseData, {}];
            });

        function prepareResponseData(data) {
            var requestData = JSON.parse(data);
            var responseActivityChart = [
                ["Days", "Session activity", "Unique users"],
                ["08 / 11", 700, 700],
                ["09 / 11", 588, 451],
                ["10 / 11", 585, 474],
                ["11 / 11", 447, 380],
                ["12 / 11", 630, 533],
                ["13 / 11", 612, 694],
                ["14 / 11", 591, 1079],
                ["15 / 11", 511, 429]
            ];

            var responseGenderChart = [
                ["Female", "Male", "Unknown"],
                [70, 61, 10]
            ];

            var responseAgeChart = [
                ["13-18", "18-21", "21+"],
                [19, 43, 69]
            ];

            var responseAvgSessionTimeChart = [
                [5, "5-30", "30+"],
                [41, 5, 136]
            ];

            var responseDevicesChart = [
                ["smartphone", "tablet", "Unknown", "desktop"],
                [132, 20, 4, 50]
            ];

            var responseEvolutionOfProfilesChart = [
                ["Days", "Profiles"],
                ["2015-11-08", 175355],
                ["2015-11-09", 175888],
                ["2015-11-10", 176218],
                ["2015-11-11", 176565],
                ["2015-11-12", 176874],
                ["2015-11-13", 177291],
                ["2015-11-14", 177783],
                ["2015-11-15", 178546],
                ["2015-11-16", 178887]
            ];

            var responseTop10LanguagesChart = [
                ["Dutch", "Unknown", "English", "Russian", "Italian", "French", "German", "Spanish", "Portuguese", "Polish"],
                [199, 169, 103, 14, 11, 10, 9, 9, 6, 5]
            ];

            var responseTotalProfilesNumber = 4025;
            var responseTotalSessionsNumber = 2012;
            var responseAverageDurationNumber = 46;
            var responseFacebookConnectNumber = 86;
            var responseTwitterConnectNumber = 14;
            var responseMostUsedDeviceName = "iPhone 6";
            var responsePeakNumber = "13-14";
            var responsePopularLanguageName = "Dutch";
            var responseTotalUsersCountedNumber = 78571;

            var heatMapResponse = [{
                lat: 51.218107,
                lng: 4.407001
            },{
                lat: 51.217107,
                lng: 4.407001
            },{
                lat: 51.217108,
                lng: 4.407002
            },{
                lat: 51.217108,
                lng: 4.407005
            },{
                lat: 51.217108,
                lng: 4.407003
            },{
                lat: 51.217109,
                lng: 4.407002
            },{
                lat: 51.217111,
                lng: 4.407001
            },{
                lat: 51.217111,
                lng: 4.407003
            },{
                lat: 51.217807,
                lng: 4.407051
            },{
                lat: 51.217507,
                lng: 4.407801
            }, {
                lat: 51.218088,
                lng: 4.414903
            }, {
                lat: 51.219455,
                lng: 4.401943
            }, {
                lat: 51.218856,
                lng: 4.401136
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.221217,
                lng: 4.396885
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.221209,
                lng: 4.396897
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.344218,
                lng: 4.321772
            }, {
                lat: 51.221583,
                lng: 4.400115
            }, {
                lat: 51.220684,
                lng: 4.399086
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.217431,
                lng: 4.417769
            }, {
                lat: 51.217444,
                lng: 4.417808
            }, {
                lat: 51.221579,
                lng: 4.39988
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.218331,
                lng: 4.402468
            }, {
                lat: 51.218107,
                lng: 4.407001
            }, {
                lat: 51.218337,
                lng: 4.402438
            }, {
                lat: 51.220193,
                lng: 4.40032
            }, {
                lat: 51.220667,
                lng: 4.39914
            }, {
                lat: 51.221217,
                lng: 4.396885
            }, {
                lat: 51.218596,
                lng: 4.421785
            }, {
                lat: 51.218059,
                lng: 4.421718
            }, {
                lat: 51.218059,
                lng: 4.421718
            }, {
                lat: 51.222586,
                lng: 4.397265
            }, {
                lat: 51.215385,
                lng: 4.409482
            }, {
                lat: 51.215463,
                lng: 4.409483
            }, {
                lat: 51.218933,
                lng: 4.394339
            }, {
                lat: 51.221857,
                lng: 4.42095
            }, {
                lat: 51.169779,
                lng: 4.394454
            },{
                lat: 51.169774,
                lng: 4.394454
            },{
                lat: 51.169774,
                lng: 4.394454
            },{
                lat: 51.169774,
                lng: 4.394458
            },{
                lat: 51.169773,
                lng: 4.394459
            },{
                lat: 51.169773,
                lng: 4.394456
            }, {
                lat: 51.215437,
                lng: 4.410285
            }, {
                lat: 51.230997,
                lng: 4.422185
            }, {
                lat: 51.231072,
                lng: 4.423377
            }, {
                lat: 51.213615,
                lng: 4.405175
            }, {
                lat: 51.228766,
                lng: 4.404814
            }, {
                lat: 51.220801,
                lng: 4.403969
            }, {
                lat: 51.213759,
                lng: 4.405183
            }, {
                lat: 51.228687,
                lng: 4.404286
            }, {
                lat: 51.230722,
                lng: 4.423086
            }, {
                lat: 51.218618,
                lng: 4.46027
            }, {
                lat: 51.230208,
                lng: 4.425917
            }, {
                lat: 51.242518,
                lng: 4.441696
            }, {
                lat: 51.241803,
                lng: 4.441543
            }, {
                lat: 51.216496,
                lng: 4.408915
            }, {
                lat: 51.204801,
                lng: 4.398321
            }, {
                lat: 51.213285,
                lng: 4.433974
            }, {
                lat: 51.277023,
                lng: 4.423753
            }, {
                lat: 51.195143,
                lng: 4.419664
            }, {
                lat: 51.214501,
                lng: 4.443714
            },{
                lat: 51.225501,
                lng: 4.443614
            },{
                lat: 51.226701,
                lng: 4.443514
            },{
                lat: 51.224501,
                lng: 4.443584
            },{
                lat: 51.224401,
                lng: 4.443714
            }, {
                lat: 51.221345,
                lng: 4.448791
            }, {
                lat: 51.222545,
                lng: 4.446961
            },{
                lat: 51.222345,
                lng: 4.448791
            }, {
                lat: 51.222745,
                lng: 4.446961
            },{
                lat: 51.221385,
                lng: 4.448791
            },{
                lat: 51.221345,
                lng: 4.448791
            }, {
                lat: 51.222645,
                lng: 4.446961
            }, {
                lat: 51.222645,
                lng: 4.446961
            }, {
                lat: 51.223809,
                lng: 4.445665
            }, {
                lat: 51.221628,
                lng: 4.446437
            }, {
                lat: 51.222817,
                lng: 4.445392
            }, {
                lat: 51.344218,
                lng: 4.321772
            }, {
                lat: 51.171359,
                lng: 4.353701
            }];

            var MostPopularFlowResponse = ["FacebookFlow",0.75];

            var upDownVolumesAndSessions = [
                ["Days", "Volume Downloaded", "Volume Uploaded", "New Sessions", "Reccurrent Sessions"],
                ["2016-03-14T10:41:23+00:00", 1641.07, 541.38, 850, 750],
                ["2016-03-15T10:41:23+00:00", 1498.49, 453.33, 750, 950],
                ["2016-03-16T10:41:23+00:00", 1370.31, 973.17, 650, 850],
                ["2016-03-17T10:41:23+00:00", 2462.11, 3804.20, 250, 650],
                ["2016-03-18T10:41:23+00:00", 6436.43, 1140.26, 550, 450],
                ["2016-03-19T10:41:23+00:00", 8081.37, 545.93, 840, 350],
                ["2016-03-20T10:41:23+00:00", 3634.80, 1985.98, 350, 750],
                ["2016-03-21T10:41:23+00:00", 3717.27, 1551.74, 250, 950]
            ];

            var newRecurringUsers = [
                ["Days", "New Users", "Recurrent Users"],
                ["2016-03-14T10:41:23+00:00", 94, 31],
                ["2016-03-15T10:41:23+00:00", 62, 14],
                ["2016-03-16T10:41:23+00:00", 96, 39],
                ["2016-03-17T10:41:23+00:00", 128, 37],
                ["2016-03-18T10:41:23+00:00", 151, 54],
                ["2016-03-19T10:41:23+00:00", 473, 60],
                ["2016-03-20T10:41:23+00:00", 213, 56],
                ["2016-03-21T10:41:23+00:00", 128, 39]
            ];

            var usageOverTimeOfDay = [
                ['Time', 'Total'],
                ['2016-03-14T00:00:23+01:00', 0],
                ['2016-03-14T01:00:23+01:00', 10],
                ['2016-03-14T02:00:23+01:00', 5],
                ['2016-03-14T03:00:23+01:00', 6],
                ['2016-03-14T04:00:23+01:00', 7],
                ['2016-03-14T05:00:23+01:00', 8],
                ['2016-03-14T06:00:23+01:00', 12],
                ['2016-03-14T07:00:23+01:00', 15],
                ['2016-03-14T08:00:23+01:00', 15],
                ['2016-03-14T09:00:23+01:00', 22],
                ['2016-03-14T10:00:23+01:00', 50],
                ['2016-03-14T11:00:23+01:00', 80],
                ['2016-03-14T12:00:23+01:00', 170],
                ['2016-03-14T13:00:23+01:00', 230],
                ['2016-03-14T14:00:23+01:00', 240],
                ['2016-03-14T15:00:23+01:00', 270],
                ['2016-03-14T16:00:23+01:00', 235],
                ['2016-03-14T17:00:23+01:00', 230],
                ['2016-03-14T18:00:23+01:00', 210],
                ['2016-03-14T19:00:23+01:00', 175],
                ['2016-03-14T20:00:23+01:00', 180],
                ['2016-03-14T21:00:23+01:00', 150],
                ['2016-03-14T22:00:23+01:00', 110],
                ['2016-03-14T23:00:23+01:00', 95]
            ];

            switch (requestData.widgetName) {
                case 'UsersAndSessionsActivityPerTimePlot':
                    return responseActivityChart;
                case 'DistributionOfGenderBar':
                    return responseGenderChart;
                case 'TotalProfilesNumber':
                    return responseTotalProfilesNumber;
                case 'TotalSessionsNumber':
                    return responseTotalSessionsNumber;
                case 'DistributionByAgeHistogram':
                    return responseAgeChart;
                case 'AvarageDurationNumber':
                    return responseAverageDurationNumber;
                case 'FacebookConnectNumber':
                    return responseFacebookConnectNumber;
                case 'TwitterConnectNumber':
                    return responseTwitterConnectNumber;
                case 'MostUsedDeviceName':
                    return responseMostUsedDeviceName;
                case 'PeakNumber':
                    return responsePeakNumber;
                case 'PopularLanguageName':
                    return responsePopularLanguageName;
                case 'AvgSessionTimeBar':
                    return responseAvgSessionTimeChart;
                case 'DistributionOfDeviceTypesTable':
                    return responseDevicesChart;
                case 'EvolutionOfProfilesChart':
                    return responseEvolutionOfProfilesChart;
                case 'TopLanguagesTable':
                    return responseTop10LanguagesChart;
                case 'TotalUsersCountedNumber':
                    return responseTotalUsersCountedNumber;
                case 'HeatMapData':
                    return heatMapResponse;
                case 'MostPopularFlow':
                    return MostPopularFlowResponse;
                case 'UpDownVolumeAndNewRecurringSessionsPerTimePlot':
                    return upDownVolumesAndSessions;
                case 'NewAndRecurringUsersPerTimePlot':
                    return newRecurringUsers;
                case 'UsageOverTimeOfDayPlot':
                    return usageOverTimeOfDay;
                default:
                    var responseData = {};
                    return responseData;
            }
        }

        // MOCKS - END ======================================================================
    }
})();

(function ()
{
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($urlRouterProvider)
    {
        // Default behaviour
        $urlRouterProvider.otherwise( function($injector) {
            var $state = $injector.get('$state');
            $state.go('login');
        });
    }

})();

angular.module("NorvaldAnalytics")

.constant("CONSTANTS", {
	"BASE_URL": "https://analytics-api.wifilab.be",
	"REQUEST_DELAY": "100",
	"MAX_CONCURRENT_REQUESTS": "3",
	"CACHE_EXPIRATION_TIME": "30",
	"LOGIN_APP_URL": "https://auth.wifilab.be",
	"CORE_API_URL": "https://core-api.wifilab.be/api-v2/",
	"APP_IDENTIFIER": "analytics",
	"GOOGLE_MAPS_API_KEY": "AIzaSyBiv5DdhmevlbB9iRYAkN-AmEXnFxES_aw"
})

;
(function() {
    'use strict';

    angular
        .module('NorvaldAnalytics')
        .config(config)
        .value('googleChartApiConfig', {
            version: '1',
            optionalSettings: {
                packages: ['corechart'],
                language: 'en'
            }
        });

    /** @ngInject */
    function config($logProvider, $httpProvider, $resourceProvider, uiGmapGoogleMapApiProvider) {
        // Set debugging mode
        $logProvider.debugEnabled(false);
        // It disable removing trailing slashes in request url, backend requiring slash at end of url
        $resourceProvider.defaults.stripTrailingSlashes = false;
        // Google Map Api Provider
        uiGmapGoogleMapApiProvider.configure({
            v: '3.20', //defaults to latest 3.X anyhow
            libraries: 'visualization'
        });

        // Http interceptor
        var interceptor = function($q, $location, store, $injector, CONSTANTS) {
            return {
                'request': function(config) {
                    var AuthService = $injector.get('AuthService');
                    if (AuthService.getAccessToken()) {
                        config.headers['X-Access-Token'] = AuthService.getTokenHeader();
                        config.headers['networks'] = AuthService.getNetworks();
                    }
                    return config;
                },

                'responseError': function(rejection) {
                    var AuthService = $injector.get('AuthService');
                    if (rejection.status == 401) { // not authenticated
                        // Remove access token from storage when it is present in storage
                        AuthService.clearData();
                        window.location = CONSTANTS.LOGIN_APP_URL + '?errorMessage=' + 'Session expired';
                    }
                    if (rejection.status == 403) { // not analytics token?
                        // Remove access token from storage when it is present in storage
                        window.location = CONSTANTS.LOGIN_APP_URL + '/app-selector?errorMessage=' + 'Authorization rejected';
                    }
                    return $q.reject(rejection);
                }
            }
        }

        $httpProvider.interceptors.push(interceptor);
    }
})();

angular.module("NorvaldAnalytics").run(["$templateCache", function($templateCache) {$templateCache.put("app/components/mostPopularFlow/mostPopularFlow.html","<label ng-bind=\"mostPopular.label\"></label> <span class=\"value\" ng-bind=\"mostPopular.displayedData\" ng-hide=\"mostPopular.loading\" style=\"\"></span><div class=\"chart\" ng-if=\"mostPopular.loading\"><div class=\"widgetLoading\" ng-show=\"mostPopular.loading\"></div></div>");
$templateCache.put("app/components/navbar/navbar.html","<div id=\"content-wrapper\"><div class=\"main-header\"><div class=\"sub-nav row\"><div class=\"col-sm-10 col-alternative\"><div id=\"main-menu-inner\"><div class=\"navbar navbar-default\"><div class=\"col-xs-12 col-sm-2 col-alternative col-with-logo\"><div class=\"wrapper-brand\"><a href=\"/\" rel=\"home\" class=\"logo icon-logo-application\"></a></div></div><div class=\"col-sm-9 col-alternative\"><div class=\"navbar-header hidden-sm hidden-md hidden-lg\"><button type=\"button\" class=\"navbar-toggle pull-right toggle-button\" ng-click=\"navbar.collapsed = !navbar.collapsed\"><span class=\"sr-only\">Toggle navigation</span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span> <span class=\"icon-bar\"></span></button></div><div class=\"navbar-collapse\" uib-collapse=\"navbar.collapsed\"><ul class=\"nav navbar-nav\"><li><a ui-sref=\"analytics\" ui-sref-active=\"active\">ANALYTICS</a></li><li><a ui-sref=\"location\" ui-sref-active=\"active\">LOCATION</a></li><li><a ui-sref=\"csv-data\" ui-sref-active=\"active\">DATA DUMP</a></li><li ng-click=\"navbar.gotoAppSelector()\" class=\"hidden-sm hidden-md hidden-lg\"><a href=\"#\">{{navbar.clientName}}</a></li><li class=\"user-nav hidden-sm hidden-md hidden-lg\" uib-dropdown=\"\"><a href=\"#\" uib-dropdown-toggle=\"\" id=\"user-dropdown\">App Selector</a></li></ul></div></div></div></div></div><div class=\"col-sm-2 col-alternative navbar-default hidden-xs\"><div class=\"user-nav\"><ul class=\"nav navbar-nav pull-right\"><li ng-click=\"navbar.gotoAppSelector()\"><a href=\"#\">{{navbar.clientName}}</a></li><li class=\"appSelector\" ng-click=\"navbar.gotoAppSelector()\"><a href=\"#\" uib-dropdown-toggle=\"\" id=\"user-dropdown\"><img class=\"appSelector\" src=\"../assets/images/app_selector_icon.svg\"></a></li></ul></div></div></div></div></div>");
$templateCache.put("app/components/filters/filters.html","<div class=\"Filters\" ng-class=\"{\'more\': filters.moreFiltersVisible, \'impersonation-mode\': filters.impersonationActive}\"><div class=\"container\"><div class=\"row\"><div class=\"col-xs-12\"><ui-select ng-model=\"filters.filters.period\" title=\"Period\" on-select=\"filters.changePeriod($item, $model)\"><ui-select-match placeholder=\"PERIOD\"><span class=\"Filters-selected-period\" ng-bind=\"$select.selected.name\"></span></ui-select-match><ui-select-choices repeat=\"item in filters.periods\"><span ng-bind=\"item.name\"></span></ui-select-choices></ui-select><p class=\"Filters-text\">OR</p><div class=\"Filters-from-to\"><input type=\"text\" class=\"form-control\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"filters.filters.date_from\" is-open=\"filters.status.fromOpened\" datepicker-options=\"filters.dateOptions\" show-button-bar=\"true\" close-text=\"Close\" ng-click=\"filters.openDatepickerFrom($event)\" placeholder=\"FROM\" max-date=\"filters.filters.date_to\" ng-change=\"filters.cancelPeriod()\" title=\"date from\" required=\"\"> <i class=\"caret\"></i></div><div class=\"Filters-from-to\"><input type=\"text\" class=\"form-control Filters-from-to\" uib-datepicker-popup=\"yyyy-MM-dd\" ng-model=\"filters.filters.date_to\" is-open=\"filters.status.toOpened\" datepicker-options=\"filters.dateOptions\" show-button-bar=\"true\" close-text=\"Close\" ng-click=\"filters.openDatepickerTo($event)\" placeholder=\"TO\" min-date=\"filters.filters.date_from\" ng-change=\"filters.cancelPeriod()\" title=\"date to\" required=\"\"> <i class=\"caret\"></i></div><div class=\"Filters-seperator Filters-seperator-second-row-for-small\"></div><div id=\"filters-second-row\"><div class=\"Filters-gender\"><div class=\"pull-left\" ng-repeat=\"gender in filters.gender\"><div class=\"Filters-gender-{{gender}}\"><input type=\"checkbox\" id=\"{{gender}}\" checked=\"\" checklist-model=\"filters.filters.gender_type\" checklist-value=\"gender\"> <label for=\"{{gender}}\" title=\"{{gender | capitalize:\'first\'}}\"><span></span></label></div></div></div><div class=\"Filters-seperator\"></div><div class=\"Filters-age pull-left\"><select class=\"form-control pull-left\" name=\"singleSelect\" ng-model=\"filters.age\"><option value=\"ALL\">All</option><option value=\"< 18\">< 18</option><option value=\"18 - 21\">18 - 21</option><option value=\"+ 21\">+ 21</option></select></div><div class=\"Filters-seperator\"></div><a href=\"\" class=\"Filters-more btn btn-link\" ng-click=\"filters.toggleMore()\"><span ng-hide=\"filters.moreFiltersVisible\">More</span> <span ng-show=\"filters.moreFiltersVisible\">Less</span> <span class=\"Filters-more-filters-word-after\">filters</span><span ng-class=\"{dropup: filters.moreFiltersVisible}\"><i class=\"caret\"></i></span></a><div class=\"Filters-seperator\"></div><a href=\"\" class=\"Filters-apply Button-green\" ng-click=\"filters.applyFilter()\">Apply <span class=\"Filters-apply-filters-word-after\">filter</span></a></div></div></div><div class=\"row Filters-additional\"><div class=\"col-xs-12\"><div isteven-multi-select=\"\" input-model=\"filters.languages\" output-model=\"filters.filters.languages\" output-properties=\"name value\" button-label=\"name\" item-label=\"name\" tick-property=\"ticked\" max-labels=\"2\" class=\"pull-left Filters-additional-multiselect\" max-height=\"250px\" translation=\"filters.languageText\" helper-elements=\"all reset filter\" group-property=\"msGroup\" ng-show=\"filters.filtersReady\"></div><div class=\"Filters-loader pull-left\" ng-hide=\"filters.filtersReady\"><img src=\"../assets/images/ring-alt.gif\" title=\"Fetching Access Points list...\"></div><div class=\"Filters-seperator\"></div><div class=\"Filters-devices-group\"><div class=\"Filters-devices pull-left\"><div class=\"pull-left\" ng-repeat=\"device in filters.devices\"><input id=\"device-{{device.name}}\" type=\"checkbox\" checked=\"\" checklist-model=\"filters.filters.device_type\" checklist-value=\"device.name\"> <label for=\"device-{{device.name}}\" title=\"{{device.toolTipText || (device.name | capitalize:\'first\')}}\"><i class=\"fa fa-{{device.icon}}\"></i></label></div></div><div class=\"Filters-seperator\"></div><div class=\"Filters-devices pull-left\"><div class=\"pull-left\" ng-repeat=\"os in filters.device_os\"><input id=\"os-{{os.name}}\" type=\"checkbox\" checked=\"\" checklist-model=\"filters.filters.device_os\" checklist-value=\"os.name\"> <label for=\"os-{{os.name}}\" title=\"{{os.toolTipText || (os.name | capitalize:\'first\')}}\"><i class=\"fa fa-{{os.icon}}\"></i></label></div></div></div><div class=\"Filters-seperator\"></div><a href=\"\" class=\"Filters-apply Button-green\" ng-click=\"filters.resetFilter()\">Reset <span class=\"Filters-apply-filters-word-after\">filters</span></a></div></div></div></div>");
$templateCache.put("app/components/networkApSelector/networkApSelector.html","<div class=\"network-ap-selector\"><div class=\"row network-ap-selector-bar\"><div class=\"col-xs-12 col-sm-7 network-ap-selector-bar-info\"><span><span class=\"network-ap-selector-bar-info-period\"><span ng-bind=\"selector.periodInfo.name\"></span> <span ng-class=\"selector.periodInfo.name ? \'network-ap-selector-bar-info-period-date\' : \'\'\" ng-bind=\"selector.periodInfo.dateFrom + \' - \' + selector.periodInfo.dateTo\"></span></span></span></div><div class=\"col-xs-12 col-sm-5 pull-right\"><div isteven-multi-select=\"\" input-model=\"selector.accessPoints\" output-model=\"selector.filters.accesspoint\" output-properties=\"name value\" button-label=\"name\" item-label=\"name\" tick-property=\"ticked\" max-labels=\"2\" class=\"dropdown-to-right-when-small APSelector\" max-height=\"250px\" translation=\"selector.accessPointsText\" helper-elements=\"all reset filter\" group-property=\"msGroup\" on-close=\"selector.applyAPChange()\"></div></div></div></div>");
$templateCache.put("app/components/impersonation/impersonation.html","<div ng-show=\"impersonation.active\" class=\"impersonationAlert\"><i class=\"impersonation-icon\">&nbsp;</i> You\'re viewing this page as {{impersonation.impersonatedUser}}. <span class=\"exitImpersonation\" ng-click=\"impersonation.exitImpersonation()\">Disable</span> to continue in normal mode</div>");
$templateCache.put("app/components/socialConnect/socialConnect.html","<label ng-bind=\"social.label\"></label> <span class=\"value\" ng-bind=\"social.displayedData\" ng-hide=\"social.loading\"></span><div class=\"chart\" ng-if=\"social.loading\"><div class=\"widgetLoading\" ng-show=\"social.loading\"></div></div>");
$templateCache.put("app/components/singleValue/singleValue.html","<label ng-bind=\"value.label\"></label> <span class=\"value\" ng-bind=\"value.displayedData | thousandSeparator\" ng-hide=\"value.loading\"></span><div class=\"chart\" ng-if=\"value.loading\"><div class=\"widgetLoading\" ng-show=\"value.loading\"></div></div>");
$templateCache.put("app/pages/csv-data/csv-data.html","<div ng-cloak=\"\"><impersonation active=\"true\"></impersonation><navbar></navbar><div class=\"Analytics\"><div class=\"container\"><div class=\"alert alert-warning\"><strong>Warning!</strong> Downloading export could take some time to process.</div><img class=\"loading\" src=\"../assets/images/ring-alt.gif\" ng-hide=\"!waiting\"><table id=\"csv-data\"><thead><tr><th ng-click=\"orderByField=\'network.name\'; reverseSort = !reverseSort\">Network <span ng-show=\"orderByField == \'network.name\'\"><span ng-show=\"!reverseSort\"><i class=\"fa fa-sort-asc\"></i></span> <span ng-show=\"reverseSort\"><i class=\"fa fa-sort-down\"></i></span></span></th><th ng-click=\"orderByField=\'date\'; reverseSort = !reverseSort\">Date <span ng-show=\"orderByField == \'date\'\"><span ng-show=\"!reverseSort\"><i class=\"fa fa-sort-asc\"></i></span> <span ng-show=\"reverseSort\"><i class=\"fa fa-sort-down\"></i></span></span></th><th ng-click=\"orderByField=\'file\'; reverseSort = !reverseSort\">File <span ng-show=\"orderByField == \'file\'\"><span ng-show=\"!reverseSort\"><i class=\"fa fa-sort-asc\"></i></span> <span ng-show=\"reverseSort\"><i class=\"fa fa-sort-down\"></i></span></span></th><th></th></tr></thead><tbody><tr ng-repeat=\"file in rawDataFiles|orderBy:orderByField:reverseSort\"><td>{{file.network.name}}</td><td>{{file.date}}</td><td>{{file.file}}</td><td><a class=\"download {{waiting}} text-center\" target=\"_blank\" download=\"{{file.file}}\" ng-click=\"getRawDataFile(\'{{ file.id }}\', \'{{file.file}}\')\"><span class=\"glyphicon glyphicon-download-alt\"></span> Download</a></td></tr></tbody></table></div></div></div>");
$templateCache.put("app/pages/analytics/analytics.html","<div ng-cloak=\"\"><navbar></navbar><analytics-filters filters=\"analytics.filters\"></analytics-filters><impersonation></impersonation><div class=\"Analytics\" ng-class=\"{\'impersonation-mode\': analytics.impersonationActive}\"><div class=\"container\"><network-ap-selector filters=\"analytics.filters\"></network-ap-selector><div class=\"row Analytics-main-widget\"><div class=\"col-lg-7 col-sm-12 Analytics-widget\"><div class=\"Analytics-widget-export\"><a class=\"glyphicon glyphicon-new-window\" uib-popover=\"\" uib-popover-template=\"\'exportPopoverTemplate\'\" popover-trigger=\"outsideClick\" popover-placement=\"top\" popover-is-open=\"popoverIsOpen\" ng-mouseenter=\"popoverIsOpen = !popoverIsOpen\"></a><script type=\"text/ng-template\" id=\"exportPopoverTemplate\"><div class=\"row Analytics-widget-export-icons\"> <div class=\"col-xs-6 Analytics-widget-export-icons-pdf\"> <a class=\"fa fa-picture-o fa-3x\" title=\"Export to PNG file\" ng-click=\"analytics.exportToPng(\'volumes-sessions-chart\')\" ng-class=\"{disabled: analytics.exportingToPngDisabled()}\"></a> </div> <div class=\"col-xs-6\"> <a class=\"fa fa-table fa-3x\" title=\"Export spreadsheet to Excel file\" ng-click=\"analytics.exportToExcel()\" ng-class=\"{disabled: analytics.exportingToExcelDisabled()}\"></a> </div> </div></script></div><linear-chart id=\"volumes-sessions-chart\" chart-config=\"analytics.volumesAndSessionsChart\" chart-title=\"volume and sessions\" h-axis-title=\"\" v-axis-title=\"\" h-axis-date-format=\"\'D/M\'\"></linear-chart></div><div class=\"col-lg-5 col-sm-12\"><div class=\"row u-margin-top-20\"><div class=\"col-xs-6\"><single-value id=\"total-users-widget\" data=\"analytics.totalUsersWidget.data\" label=\"Total users\" unit=\"\"></single-value></div><div class=\"col-xs-6\"><single-value id=\"total-sessions-widget\" data=\"analytics.totalSessionsWidget.data\" label=\"Total sessions\" unit=\"\"></single-value></div></div><div class=\"row u-margin-top-20\"><div class=\"col-sm-12\"><pie-chart id=\"gender-chart\" chart-config=\"analytics.genderChart\" chart-title=\"\"></pie-chart></div><div class=\"col-sm-12\"><pie-chart id=\"age-chart\" chart-config=\"analytics.ageChart\" chart-title=\"\"></pie-chart></div></div></div></div><div class=\"Analytics-general-statistics-widget\"><div class=\"row\"><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value\"><single-value id=\"average-duration-widget\" data=\"analytics.averageDurationWidget.data\" label=\"Average duration\" unit=\"min\" convert-from-sec-to-min=\"true\" loading=\"analytics.averageDurationWidget.loading\"></single-value></div><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value\"><most-popular-flow mostpopularflow=\"analytics.mostPopularFlowWidget.data\"></most-popular-flow></div><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value single-value\"><label>Most active AP group</label> <span class=\"value Analytics-general-statistics-widget-single-value-oneLine\" ng-bind=\"analytics.mostActiveApsGroup\" ng-show=\"analytics.mostActiveApsGroupLoaded\"></span><div class=\"chart\" ng-hide=\"mostActiveApsGroup.loading\"><div class=\"widgetLoading\" ng-hide=\"analytics.mostActiveApsGroupLoaded\"></div></div></div><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value\"><single-value id=\"most-used-device-widget\" data=\"analytics.mostUsedDeviceWidget.data\" label=\"Most used device\" unit=\"\" loading=\"analytics.mostUsedDeviceWidget.loading\"></single-value></div><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value\"><single-value id=\"peak-widget\" data=\"analytics.peakWidget.data\" label=\"Peak\" unit=\"\" loading=\"analytics.peakWidget.loading\"></single-value></div><div class=\"col-md-2 col-sm-2 col-xs-4 Analytics-general-statistics-widget-single-value\"><single-value id=\"popular-language-widget\" data=\"analytics.popularLanguageWidget.data\" label=\"Popular language\" unit=\"\" loading=\"analytics.popularLanguageWidget.loading\"></single-value></div></div></div><div class=\"Analytics-addition-statistics-widget\"><div class=\"row\"><div class=\"col-md-4 col-sm-6 col-xs-12\"><column-chart id=\"average-session-time-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.averageSessionTimeChart\" chart-title=\"AVERAGE SESSION TIME\" h-axix-title=\"\" v-axix-title=\"\"></column-chart></div><div class=\"col-md-4 col-sm-6 col-xs-12\"><pie-chart id=\"devices-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.devicesChart\" chart-title=\"DEVICES\"></pie-chart></div><div class=\"col-md-4 col-sm-12 col-xs-12\"><linear-chart id=\"evolution-of-profiles-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.evolutionOfProfilesChart\" chart-title=\"Evolution Of Profiles\" h-axis-date-format=\"\'D/M\'\"></linear-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><linear-chart id=\"activity-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.activityChart\" chart-title=\"ACTIVITY\" h-axix-title=\"\" v-axix-title=\"\" h-axis-date-format=\"\'D/M\'\"></linear-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><linear-chart id=\"recuring-new-users-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.usersChart\" chart-title=\"Users\" h-axix-title=\"\" v-axix-title=\"\" h-axis-date-format=\"\'D/M\'\"></linear-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><linear-chart id=\"usage-over-time-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.usageOverTimeChart\" chart-title=\"Usage\" h-axix-title=\"\" v-axix-title=\"\" h-axis-date-format=\"\"></linear-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"top-10-languages-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.top10LanguagesChart\" chart-title=\"Top 10 Languages\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"most-popular-10-aps-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.mostPopular10ApsChart\" chart-title=\"10 most popular Aps\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"most-popular-10-aps-groups-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.mostPopular10ApsGroupsChart\" chart-title=\"10 most popular Aps Groups\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><area-chart id=\"sessions-stacked-plot-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.sessionsStackedPlotChart\" chart-title=\"Sessions Stacked Plot\" h-axis-date-format=\"\'D/M\'\"></area-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><area-chart id=\"bandwidth-stacked-plot-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.bandwidthStackedPlotChart\" chart-title=\"Bandwidth Stacked Plot\" h-axis-date-format=\"\'D/M\'\"></area-chart></div><div class=\"col-md-6 col-sm-6 col-xs-12 Analytics-addition-statistics-widget-column\"><column-chart id=\"average-session-bandwidth-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.averageSessionBandwidthChart\" chart-title=\"Average Session Bandwidth\" h-axix-title=\"\" v-axix-title=\"\"></column-chart></div><div class=\"col-md-6 col-sm-6 col-xs-12 Analytics-addition-statistics-widget-column\"><column-chart id=\"average-session-per-profile-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.averageSessionPerProfileChart\" chart-title=\"Average Session per Profile\" h-axix-title=\"\" v-axix-title=\"\"></column-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"login-method-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.loginMethodChart\" chart-title=\"Login method\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"device-brand-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.deviceBrandChart\" chart-title=\"Device Brand\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"device-browser-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.deviceBrowserChart\" chart-title=\"Device Browser\"></pie-chart></div><div class=\"col-md-6 col-sm-12 col-xs-12 Analytics-addition-statistics-widget-column\"><pie-chart id=\"device-os-chart\" class=\"Analytics-column-widget\" chart-config=\"analytics.deviceOSChart\" chart-title=\"Device OS\"></pie-chart></div></div></div></div></div></div>");
$templateCache.put("app/pages/location/location.html","<div ng-cloak=\"\"><navbar></navbar><analytics-filters filters=\"location.filters\"></analytics-filters><impersonation></impersonation><div class=\"Location\" ng-class=\"{\'impersonation-mode\': location.impersonationActive}\"><div class=\"container\"><network-ap-selector filters=\"analytics.filters\"></network-ap-selector><div class=\"row\"><div class=\"Location-widget\"><div class=\"col-sm-12 Location-widget-map\" id=\"time-spent-per-ap-map\"><div class=\"loadingSpinner\" ng-show=\"location.mapIsLoading()\"></div><div ng-class=\"location.mapIsLoading() && \'Location-widget-map-loading\'\"><div class=\"Location-widget-map-switcher\" ng-hide=\"location.map.heatDataLoading\"><a href=\"\" ng-click=\"location.toggleHeatMap()\" ng-bind=\"location.map.showHeat ? \'HIDE HEATMAP\' : \'SHOW HEATMAP\'\"></a></div><ui-gmap-google-map center=\"location.map.center\" zoom=\"location.map.zoom\" bounds=\"location.map.bounds\"><ui-gmap-circle ng-repeat=\"c in location.circles | filter: (location.map.showHeat || \'\') && {clickable: true} track by c.id\" center=\"c.center\" stroke=\"c.stroke\" fill=\"c.fill\" radius=\"c.radius\" visible=\"c.visible\" geodesic=\"c.geodesic\" editable=\"c.editable\" draggable=\"c.draggable\" clickable=\"c.clickable\" control=\"c.control\" events=\"c.events\"></ui-gmap-circle><ui-gmap-layer id=\"heat-map-layer\" namespace=\"visualization\" type=\"HeatmapLayer\" show=\"location.map.showHeat\" oncreated=\"location.map.heatLayerCallback\"></ui-gmap-layer><ui-gmap-window ng-repeat=\"c in location.circles track by c.id\" coords=\"c.center\" show=\"location.popupIsOpened(c.id)\" closeclick=\"location.closePopup()\"><div><h6>{{c.data.apName}}</h6><p>time spent: {{c.data.time}} {{c.data.unit}}</p></div></ui-gmap-window></ui-gmap-google-map><div class=\"Location-map-legend\"><div class=\"Location-map-legend-entry green\"><i class=\"fa fa-circle\"></i> high performance</div><div class=\"Location-map-legend-entry yellow\"><i class=\"fa fa-circle\"></i> mid performance</div><div class=\"Location-map-legend-entry red\"><i class=\"fa fa-circle\"></i> low performance</div></div></div></div></div></div><div class=\"Location-general-statistics-widget\"><div class=\"row\"><div class=\"col-lg-4 col-md-4 col-sm-6 col-md-offset-0 col-xs-offset-4 Location-general-statistics-widget-single-values\"><div class=\"col-xs-12\"><single-value id=\"total-users-widget\" data=\"location.totalUsersWidget.data\" label=\"Total users\" unit=\"\"></single-value></div></div><div class=\"col-lg-4 col-md-6 col-xs-offset-2 col-md-offset-0 Location-general-statistics-widget-column\"><pie-chart id=\"gender-chart\" chart-config=\"location.genderChart\" chart-title=\"\"></pie-chart></div><div class=\"col-lg-4 col-md-6 col-xs-offset-2 col-md-offset-4 col-lg-offset-0 Location-general-statistics-widget-column\"><pie-chart id=\"age-chart\" chart-config=\"location.ageChart\" chart-title=\"\"></pie-chart></div></div></div></div></div></div>");
$templateCache.put("app/pages/login/login.html","<div class=\"container\" ng-cloak=\"\"><section id=\"users\" class=\"Login\"><div class=\"row\"><div class=\"col-xs-12 / col-sm-8 col-sm-offset-2 / col-md-6 col-md-offset-3 / col-lg-5 col-lg-offset-3\"><a href=\"/\" class=\"logo\"><img class=\"img-responsive\" src=\"/assets/images/citymesh-logo.png\" alt=\"logo\"></a><form ng-submit=\"login.login()\" class=\"Login-form\"><div class=\"alert alert-danger\" ng-if=\"login.error\" role=\"alert\"><a class=\"close\" ng-click=\"login.clearErrors()\">&times;</a> <span class=\"glyphicon glyphicon-exclamation-sign\" aria-hidden=\"true\"></span> <span class=\"sr-only\"></span><span id=\"login-error-message\" ng-bind=\"login.error\"></span></div><div class=\"form-group\"><label class=\"Login-form-label\" for=\"username\">Username: <abbr title=\"Required\">*</abbr></label> <input ng-model=\"login.user.username\" id=\"username\" name=\"_username\" type=\"text\" class=\"form-control input-lg\" required=\"\"></div><div class=\"form-group\"><label class=\"Login-form-label\" for=\"password\">Password: <abbr title=\"Required\">*</abbr></label> <input type=\"password\" value=\"\" id=\"password\" name=\"_password\" class=\"form-control input-lg\" required=\"\" ng-model=\"login.user.password\"></div><p>Do you have a question or are you having issues? Contact us at <a href=\"mailto:helpdesk@citymesh.com\">helpdesk@citymesh.com</a>!</p><button type=\"submit\" id=\"submit\" name=\"_submit\" class=\"btn btn-success pull-right\" ng-disabled=\"login.loginProcess\">Login<i class=\"icon iconArrowWhiteRight\"></i></button><div class=\"loadingSpinner\"></div></form></div></div></section></div>");
$templateCache.put("app/pages/delegatedLogin/delegatedLogin.html","<div class=\"container\" ng-cloak=\"\"><section id=\"users\" class=\"Login\"><div class=\"row\"><div class=\"loadingSpinner\"></div></div></section></div>");
$templateCache.put("app/components/charts/areaChart/areaChart.html","<p class=\"Analytics-widget-title\">{{ chart.chartTitle }}</p><div class=\"chart\" ng-if=\"chart.loading\"><div class=\"widgetLoading\" ng-show=\"chart.loading\"></div></div><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\" ng-if=\"!chart.loading\"></div>");
$templateCache.put("app/components/charts/columnChart/columnChart.html","<p class=\"Analytics-widget-title\">{{ chart.chartTitle }}</p><div class=\"chart\" ng-if=\"chart.loading\"><div class=\"widgetLoading\" ng-show=\"chart.loading\"></div></div><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\" ng-if=\"!chart.loading\"></div>");
$templateCache.put("app/components/charts/customChartLegend/customChartLegend.html","<div class=\"custom-chart-legend\"><ul ng-class=\"legend.listStyleType\" ng-hide=\"legend.advanced\"><li ng-repeat=\"legendRow in legend.data.defaultData track by $index\" ng-init=\"rowIndex = $index\" ng-style=\"legend.styleColorForLabel(legendRow[0]) || { color: legend.colors[$index] }\"><span ng-show=\"legend.icons\" ng-class=\"legend.iconForLabel(legendRow[0]) || legend.icons[$index]\" class=\"custom-chart-legend-icon\"></span> <span ng-repeat=\"element in legendRow track by $index\"><span ng-if=\"$index == 0\"><span ng-bind=\"element\" class=\"custom-chart-legend-label\" title=\"{{element | capitalize:\'first\'}}\"></span></span> <span ng-if=\"$index > 0\"><span ng-bind=\"element | thousandSeparator\" class=\"custom-chart-legend-value custom-chart-legend-percentage\" ng-if=\"$index == legendRow.length - 1\"></span></span></span></li></ul><div class=\"row custom-chart-legend-devices\" ng-if=\"legend.advanced==\'devices\'\"><div class=\"col-xs-4 custom-chart-legend-devices-element\" ng-style=\"legend.styleColorForLabel(\'smartphone\')\"><div class=\"custom-chart-legend-devices-element-icon mobile\"><i class=\"fa fa-3x fa-mobile\" title=\"Smartphone\"></i></div><div class=\"custom-chart-legend-devices-values-group\"><div class=\"custom-chart-legend-devices-element-percentage\"><span ng-bind=\"(legend.data.smartphone.percentage || \'0%\') | thousandSeparator\"></span></div><div class=\"custom-chart-legend-devices-element-value\"><span ng-bind=\"(legend.data.smartphone.value || 0) | thousandSeparator\"></span></div></div></div><div class=\"col-xs-4 custom-chart-legend-devices-element\" ng-style=\"legend.styleColorForLabel(\'tablet\')\"><div class=\"custom-chart-legend-devices-element-icon tablet\"><i class=\"fa fa-3x fa-tablet\" title=\"Tablet\"></i></div><div class=\"custom-chart-legend-devices-values-group\"><div class=\"custom-chart-legend-devices-element-percentage\"><span ng-bind=\"(legend.data.tablet.percentage || \'0%\') | thousandSeparator\"></span></div><div class=\"custom-chart-legend-devices-element-value\"><span ng-bind=\"(legend.data.tablet.value || 0) | thousandSeparator\"></span></div></div></div><div class=\"col-xs-4 custom-chart-legend-devices-element\" ng-style=\"legend.styleColorForLabel(\'desktop\')\"><div class=\"custom-chart-legend-devices-element-icon desktop\"><i class=\"fa fa-3x fa-desktop\" title=\"Desktop\"></i></div><div class=\"custom-chart-legend-devices-values-group\"><div class=\"custom-chart-legend-devices-element-percentage\"><span ng-bind=\"(legend.data.desktop.percentage || \'0%\') | thousandSeparator\"></span></div><div class=\"custom-chart-legend-devices-element-value\"><span ng-bind=\"(legend.data.desktop.value || 0) | thousandSeparator\"></span></div></div></div><p class=\"custom-chart-legend-devices-unknown-label\">and <span class=\"custom-chart-legend-devices-unknown-value\" ng-bind=\"(legend.data.Unknown.value || 0) | thousandSeparator\"></span> unknown devices</p></div></div>");
$templateCache.put("app/components/charts/linearChart/linearChart.html","<p class=\"Analytics-widget-title\">{{ chart.chartTitle }}</p><div class=\"chart\" ng-if=\"chart.loading\"><div class=\"widgetLoading\" ng-show=\"chart.loading\"></div></div><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\" ng-if=\"!chart.loading\"></div>");
$templateCache.put("app/components/charts/pieChart/pieChart.html","<div class=\"Pie-chart\"><p class=\"Analytics-widget-title\">{{ chart.chartTitle }}</p><div class=\"chart\" ng-if=\"chart.loading\"><div class=\"widgetLoading\" ng-show=\"chart.loading\"></div></div><div class=\"row chart-legend-container\" ng-show=\"chart.chartConfig.legend.custom && !chart.loading\"><div class=\"col-md-12 Pie-chart-legend horizontal\" ng-show=\"chart.chartConfig.legend.position==\'top\'\"><custom-chart-legend data=\"chart.customLegendData\" legend-style=\"chart.chartConfig.legend.style\" colors=\"chart.legendStyleColors\" icons=\"chart.legendIcons\" class=\"legend-top\"></custom-chart-legend></div><div class=\"col-md-12\" ng-hide=\"chart.displayInMiddle\"><div class=\"col-lg-8 col-md-7 col-sm-8 col-xs-8\" ng-show=\"chart.chartConfig.legend.position==\'left\'\"><custom-chart-legend data=\"chart.customLegendData\" legend-style=\"chart.chartConfig.legend.style\" colors=\"chart.legendStyleColors\" icons=\"chart.legendIcons\" class=\"legend-left\"></custom-chart-legend></div><div class=\"col-lg-4 col-md-5 col-sm-4 col-xs-4\"><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\"></div></div><div class=\"col-lg-8 col-md-7 col-sm-8 col-xs-8\" ng-show=\"chart.chartConfig.legend.position==\'right\'\"><custom-chart-legend data=\"chart.customLegendData\" legend-style=\"chart.chartConfig.legend.style\" colors=\"chart.legendStyleColors\" icons=\"chart.legendIcons\" class=\"legend-right\"></custom-chart-legend></div></div><div class=\"col-md-12\" ng-show=\"chart.displayInMiddle\"><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\"></div></div><div class=\"col-md-12 Pie-chart-legend horizontal\" ng-show=\"chart.chartConfig.legend.position==\'bottom\'\"><custom-chart-legend data=\"chart.customLegendData\" legend-style=\"chart.chartConfig.legend.style\" colors=\"chart.legendStyleColors\" icons=\"chart.legendIcons\" advanced=\"chart.advanced\" class=\"legend-bottom\"></custom-chart-legend></div></div><div google-chart=\"\" class=\"chart\" chart=\"chart.chartObject\" ng-if=\"!chart.chartConfig.legend.custom && !chart.loading\"></div></div>");}]);